var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 728,
    height: 424.665,
    viewBox: "0 0 728 424.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e0e0e0;}.b{opacity:0.8;}.c{fill:#fff;}.d{opacity:0.3;}.e{fill:#ebebeb;}.f{fill:#263238;}.g{fill:#131313;}.h{fill:#ffbe9d;}.i{fill:#eb996e;}.j{fill:#b167b6;}.k{fill:#2f2f2f;}.l{fill:#ff1744;}.m{fill:#585858;}.n{fill:#fe9900;}.o{fill:#ababab;}.p{opacity:0.2;}.q{fill:#455a64;}.r{fill:#fafafa;}.s{opacity:0.4;}.t{fill:#e5cce7;}.u{fill:#2a022d;}.v{fill:#7e0386;}.w{fill:#cb9ace;}.x{fill:#e8505b;}.y{fill:#b78876;}.z{fill:#aa6550;}.aa,.ad{fill:none;stroke-miterlimit:10;}.aa{stroke:#f3a7ad;}.ab{fill:#434343;}.ac{fill:silver;}.ad{stroke:#fff;stroke-width:0.05px;}.ae{fill:#63036a;}.af{opacity:0.7;}.ag{fill:#6d6d6d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.637 -45.571)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.144 218.98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.567 4.336)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.613 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M674.005,338.431c0-.208.976-.378,2.181-.378s2.182.17,2.182.378-.976.379-2.182.379S674.005,338.641,674.005,338.431Z",
    transform: "translate(-674.005 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.884 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M666.3,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S666.3,338.641,666.3,338.431Z",
    transform: "translate(-666.297 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.156 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M658.59,338.431c0-.208.976-.378,2.182-.378s2.181.17,2.181.378-.976.379-2.181.379S658.59,338.641,658.59,338.431Z",
    transform: "translate(-658.59 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.427 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M650.882,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S650.882,338.641,650.882,338.431Z",
    transform: "translate(-650.882 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.699 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M643.175,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S643.175,338.641,643.175,338.431Z",
    transform: "translate(-643.175 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.97 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M635.467,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S635.467,338.641,635.467,338.431Z",
    transform: "translate(-635.467 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.242 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M627.76,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S627.76,338.641,627.76,338.431Z",
    transform: "translate(-627.76 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.512 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M620.052,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S620.052,338.641,620.052,338.431Z",
    transform: "translate(-620.052 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.784 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M612.345,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S612.345,338.641,612.345,338.431Z",
    transform: "translate(-612.345 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.056 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M604.638,338.431c0-.208.976-.378,2.181-.378s2.182.17,2.182.378-.976.379-2.182.379S604.638,338.641,604.638,338.431Z",
    transform: "translate(-604.638 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.327 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M596.93,338.431c0-.208.977-.378,2.182-.378s2.182.17,2.182.378-.977.379-2.182.379S596.93,338.641,596.93,338.431Z",
    transform: "translate(-596.93 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.599 106.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M589.223,338.431c0-.208.976-.378,2.181-.378s2.182.17,2.182.378-.976.379-2.182.379S589.223,338.641,589.223,338.431Z",
    transform: "translate(-589.223 -338.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 104.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,336.172c.208,0,.378.977.378,2.182,0,.108,0,.212,0,.326l-.374-.374c1.051.027,1.855.185,1.855.374s-.8.348-1.855.375l-.37.01,0-.385c0-.114,0-.219,0-.326C583.4,337.149,583.566,336.172,583.776,336.172Z",
    transform: "translate(-583.396 -336.172)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 95.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,328.465c.208,0,.378.976.378,2.181s-.17,2.182-.378,2.182-.379-.976-.379-2.182S583.566,328.465,583.776,328.465Z",
    transform: "translate(-583.396 -328.465)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 87.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,320.757c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,320.757,583.776,320.757Z",
    transform: "translate(-583.396 -320.757)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 78.283)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,313.05c.208,0,.378.976.378,2.181s-.17,2.182-.378,2.182-.379-.976-.379-2.182S583.566,313.05,583.776,313.05Z",
    transform: "translate(-583.396 -313.05)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 69.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,305.342c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,305.342,583.776,305.342Z",
    transform: "translate(-583.396 -305.342)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 60.826)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,297.635c.208,0,.378.976.378,2.181s-.17,2.182-.378,2.182-.379-.976-.379-2.182S583.566,297.635,583.776,297.635Z",
    transform: "translate(-583.396 -297.635)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 52.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,289.927c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,289.927,583.776,289.927Z",
    transform: "translate(-583.396 -289.927)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 43.369)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,282.22c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,282.22,583.776,282.22Z",
    transform: "translate(-583.396 -282.22)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.639)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,274.512c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,274.512,583.776,274.512Z",
    transform: "translate(-583.396 -274.512)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 25.911)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,266.8c.208,0,.378.977.378,2.181s-.17,2.183-.378,2.183-.379-.977-.379-2.183S583.566,266.8,583.776,266.8Z",
    transform: "translate(-583.396 -266.805)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.182)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,259.1c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,259.1,583.776,259.1Z",
    transform: "translate(-583.396 -259.097)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.454)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.776,251.39c.208,0,.378.977.378,2.182s-.17,2.182-.378,2.182-.379-.977-.379-2.182S583.566,251.39,583.776,251.39Z",
    transform: "translate(-583.396 -251.39)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.071)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M584.429,244.3c0,.105-.25.2-.653.27l.269-.27a9.562,9.562,0,0,1,.109,1.528c0,1.206-.17,2.182-.378,2.182s-.379-.976-.379-2.182a9.562,9.562,0,0,1,.109-1.528l.052-.308.219.037C584.179,244.094,584.429,244.19,584.429,244.3Z",
    transform: "translate(-583.396 -243.988)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.396)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M592.526,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S592.526,244.095,592.526,244.3Z",
    transform: "translate(-588.161 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.126)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M600.234,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S600.234,244.095,600.234,244.3Z",
    transform: "translate(-595.869 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.854)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M607.941,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S607.941,244.095,607.941,244.3Z",
    transform: "translate(-603.576 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.583)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M615.648,244.3c0,.208-.976.378-2.181.378s-2.182-.17-2.182-.378.976-.379,2.182-.379S615.648,244.095,615.648,244.3Z",
    transform: "translate(-611.284 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.311)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M623.356,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S623.356,244.095,623.356,244.3Z",
    transform: "translate(-618.991 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.04 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.182,
    cy: 0.379,
    rx: 2.182,
    ry: 0.379
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.768)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M638.771,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S638.771,244.095,638.771,244.3Z",
    transform: "translate(-634.406 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.497)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M646.477,244.3c0,.208-.976.378-2.181.378s-2.182-.17-2.182-.378.976-.379,2.182-.379S646.477,244.095,646.477,244.3Z",
    transform: "translate(-642.114 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.225)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M654.186,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S654.186,244.095,654.186,244.3Z",
    transform: "translate(-649.821 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.954)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M661.893,244.3c0,.208-.976.378-2.181.378s-2.182-.17-2.182-.378.976-.379,2.182-.379S661.893,244.095,661.893,244.3Z",
    transform: "translate(-657.529 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.683)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M669.6,244.3c0,.208-.977.378-2.182.378s-2.182-.17-2.182-.378.977-.379,2.182-.379S669.6,244.095,669.6,244.3Z",
    transform: "translate(-665.236 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.307,244.3c0,.208-.976.378-2.182.378s-2.181-.17-2.181-.378.976-.379,2.181-.379S677.307,244.095,677.307,244.3Z",
    transform: "translate(-672.944 -243.925)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 3.541)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,251.417c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,251.417,677.9,251.417Z",
    transform: "translate(-677.524 -247.052)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 12.27)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,259.123c-.208,0-.378-.976-.378-2.181s.17-2.182.378-2.182.379.976.379,2.182S678.112,259.123,677.9,259.123Z",
    transform: "translate(-677.524 -254.76)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 20.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,266.832c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,266.832,677.9,266.832Z",
    transform: "translate(-677.524 -262.467)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 29.728)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,274.538c-.208,0-.378-.976-.378-2.181s.17-2.182.378-2.182.379.976.379,2.182S678.112,274.538,677.9,274.538Z",
    transform: "translate(-677.524 -270.175)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 38.456)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,282.247c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,282.247,677.9,282.247Z",
    transform: "translate(-677.524 -277.882)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 47.185)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,289.953c-.208,0-.378-.976-.378-2.182s.17-2.181.378-2.181.379.976.379,2.181S678.112,289.953,677.9,289.953Z",
    transform: "translate(-677.524 -285.59)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 55.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,297.662c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,297.662,677.9,297.662Z",
    transform: "translate(-677.524 -293.297)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 64.642)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,305.368c-.208,0-.378-.976-.378-2.181s.17-2.182.378-2.182.379.976.379,2.182S678.112,305.368,677.9,305.368Z",
    transform: "translate(-677.524 -301.005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 73.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,313.077c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,313.077,677.9,313.077Z",
    transform: "translate(-677.524 -308.712)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 82.099)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,320.784c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,320.784,677.9,320.784Z",
    transform: "translate(-677.524 -316.419)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 90.828)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,328.492c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.976.379,2.182S678.112,328.492,677.9,328.492Z",
    transform: "translate(-677.524 -324.127)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.599 99.556)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M677.9,336.2c-.208,0-.378-.977-.378-2.182s.17-2.182.378-2.182.379.977.379,2.182S678.112,336.2,677.9,336.2Z",
    transform: "translate(-677.524 -331.834)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.895,
    height: 7.895,
    transform: "translate(106.597 106.286)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.895,
    height: 7.895,
    transform: "translate(-0.002 107.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.895,
    height: 7.895,
    transform: "translate(106.597 -0.001)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.895,
    height: 7.895,
    transform: "translate(-0.002 0.768)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(431.636 118.235)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.391 0.391)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 218.295,
    height: 146.162
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M503.357,219.986s-.023-.914-.034-2.659-.019-4.339-.034-7.712c-.019-6.765-.045-16.689-.081-29.4-.039-25.393-.1-61.9-.163-106.4l.312.313-218.277.078h-.018l.391-.391c-.011,52.071-.023,101.587-.032,146.162l-.359-.357,157.269.176c19.255.04,34.49.074,44.93.1l11.952.044q2.026.015,3.085.023c.7.006,1.06.021,1.06.021s-.336.013-1.018.021l-3.045.021-11.879.044c-10.422.021-25.63.055-44.851.1l-157.5.176-.359,0v-.36c-.01-44.575-.021-94.091-.032-146.162v-.391h.409l218.277.079h.313v.312c-.069,44.583-.126,81.15-.165,106.592-.034,12.675-.061,22.577-.079,29.324-.016,3.349-.027,5.91-.035,7.653C503.38,219.117,503.357,219.986,503.357,219.986Z",
    transform: "translate(-284.671 -73.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.391 13.043)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M284.913,81.9c0-.216,48.831-.391,109.053-.391,60.242,0,109.061.174,109.061.391s-48.82.391-109.061.391C333.744,82.289,284.913,82.114,284.913,81.9Z",
    transform: "translate(-284.913 -81.507)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.505 5.106)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M291.578,78.342a1.749,1.749,0,1,1-1.749-1.749A1.75,1.75,0,0,1,291.578,78.342Z",
    transform: "translate(-288.079 -76.593)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(5.994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M295.289,78.342a1.749,1.749,0,1,1-1.749-1.749A1.75,1.75,0,0,1,295.289,78.342Z",
    transform: "translate(-291.79 -76.593)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(11.903)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M298.947,78.342a1.749,1.749,0,1,1-1.749-1.749A1.75,1.75,0,0,1,298.947,78.342Z",
    transform: "translate(-295.448 -76.593)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.158 28.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 58.23,
    height: 58.23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.307 44.744)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M440.164,101.525c0,.215-22.711.391-50.719.391s-50.724-.176-50.724-.391,22.706-.393,50.724-.393S440.164,101.308,440.164,101.525Z",
    transform: "translate(-338.721 -101.132)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.307 55.565)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M440.164,108.224c0,.215-22.711.391-50.719.391s-50.724-.176-50.724-.391,22.706-.393,50.724-.393S440.164,108.007,440.164,108.224Z",
    transform: "translate(-338.721 -107.831)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.307 66.386)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M440.164,114.923c0,.215-22.711.391-50.719.391s-50.724-.176-50.724-.391,22.706-.393,50.724-.393S440.164,114.706,440.164,114.923Z",
    transform: "translate(-338.721 -114.53)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.307 77.207)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M398.675,121.62a13.413,13.413,0,0,1-2.355.153c-1.657.032-3.819.073-6.424.124-5.426.071-12.919.115-21.2.115s-15.774-.044-21.2-.115c-2.605-.052-4.767-.092-6.424-.124a13.412,13.412,0,0,1-2.355-.153,13.748,13.748,0,0,1,2.355-.152l6.424-.124c5.426-.071,12.921-.115,21.2-.115s15.77.044,21.2.115l6.424.124A13.749,13.749,0,0,1,398.675,121.62Z",
    transform: "translate(-338.721 -121.229)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.802 106.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.365,
    height: 27.365
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.43 106.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.365,
    height: 27.365
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(122.058 106.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.366,
    height: 27.365
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.686 106.54)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 27.365,
    height: 27.365
  }))), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(111.64 102.236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.127 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.17,77.108h99.317v144H75.847Z",
    transform: "translate(-75.17 -77.108)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.677 0.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 98.413,
    height: 142.646,
    transform: "translate(98.413 142.646) rotate(180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M166.534,77.108v144H66.768v-144Zm-1.353,142.646V78.461H68.121V219.754Z",
    transform: "translate(-66.768 -77.108)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.58 15.845)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.324 0.282)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 73.959,
    height: 111.747
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.1,93.771s.013.192.019.551c0,.378.011.9.018,1.589.01,1.416.022,3.471.04,6.137.02,5.367.049,13.172.087,23.028.039,19.707.094,47.6.159,80.442L80.1,205.2l73.95-.029h.009l-.352.352c.027-42.154.052-81.018.072-111.746l.28.28L100.245,93.9l-14.88-.072-3.91-.031c-.886-.011-1.357-.031-1.357-.031s.43-.019,1.3-.03l3.857-.032,14.818-.071,53.985-.148h.28v.282c.019,30.728.044,69.593.072,111.746v.353h-.362l-73.95-.03h-.324v-.323c.065-32.928.12-60.9.159-80.654.038-9.825.067-17.6.087-22.955.017-2.638.03-4.672.039-6.072.009-.669.015-1.183.019-1.552C80.085,93.939,80.1,93.771,80.1,93.771Z",
    transform: "translate(-79.774 -93.49)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.394 127.87)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.182,224.764a12.015,12.015,0,0,1,1.588-2.452c1.054-1.46,2.549-3.447,4.265-5.592s3.343-4.033,4.559-5.362a11.592,11.592,0,0,1,2.091-2.043c.15.133-2.679,3.562-6.1,7.846S67.342,224.89,67.182,224.764Z",
    transform: "translate(-67.175 -209.311)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.67 0.674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.467,77.808c.153-.121,3.014,3.24,6.39,7.506s5.99,7.824,5.837,7.944-3.013-3.239-6.39-7.506S67.315,77.929,67.467,77.808Z",
    transform: "translate(-67.46 -77.805)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.207 0.787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.006 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.793,77.925l-12.89,15.9",
    transform: "translate(-155.903 -77.925)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M155.9,93.829c-.151-.122,2.612-3.782,6.171-8.173s6.568-7.854,6.719-7.731-2.611,3.782-6.171,8.174S156.054,93.952,155.9,93.829Z",
    transform: "translate(-155.897 -77.922)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.989 128.028)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M168.806,224.77c-.153.121-2.984-3.2-6.324-7.426s-5.923-7.745-5.77-7.865,2.983,3.2,6.324,7.428S168.959,224.649,168.806,224.77Z",
    transform: "translate(-156.705 -209.475)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.935 46.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M122.5,152.315H109.487l-1.549,3.586a7.972,7.972,0,0,0-.761,2.962,2.459,2.459,0,0,0,1.25,2.283,10.529,10.529,0,0,0,3.614.653v1H99.787v-1a5.484,5.484,0,0,0,3.261-1.644A21.876,21.876,0,0,0,106.2,154.6l13.177-29.4h.517l13.287,30.214q1.9,4.293,3.124,5.407a4.269,4.269,0,0,0,2.61.979v1H121.09v-1h.733a5.585,5.585,0,0,0,3.016-.6,1.452,1.452,0,0,0,.6-1.25,3.349,3.349,0,0,0-.162-1.006q-.055-.244-.815-2.037Zm-.924-2.011-5.488-12.689L110.438,150.3Z",
    transform: "translate(-99.787 -125.199)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M461.036,104.871a2.656,2.656,0,0,1,1.18-.137l.4.008-.129.128c.019-.457.069-.782.129-.782s.109.325.128.782l.006.127-.134,0-.4.008A2.682,2.682,0,0,1,461.036,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M457.884,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S457.884,104.946,457.884,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M454.732,104.871c0-.076.352-.137.788-.137s.788.061.788.137-.353.136-.788.136S454.732,104.946,454.732,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M451.579,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.352.136-.788.136S451.579,104.946,451.579,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M448.427,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S448.427,104.946,448.427,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M445.274,104.871c0-.076.353-.137.788-.137s.789.061.789.137-.353.136-.789.136S445.274,104.946,445.274,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M442.122,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S442.122,104.946,442.122,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.969,104.871c0-.076.353-.137.789-.137s.788.061.788.137-.353.136-.788.136S438.969,104.946,438.969,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M435.817,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.352.136-.788.136S435.817,104.946,435.817,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.665,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S432.665,104.946,432.665,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M429.512,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.352.136-.788.136S429.512,104.946,429.512,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M426.36,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S426.36,104.946,426.36,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M423.207,104.871c0-.076.353-.137.789-.137s.788.061.788.137-.353.136-.788.136S423.207,104.946,423.207,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M420.055,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S420.055,104.946,420.055,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M416.9,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S416.9,104.946,416.9,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M413.75,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.352.136-.788.136S413.75,104.946,413.75,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M410.6,104.871c0-.076.353-.137.788-.137s.788.061.788.137-.353.136-.788.136S410.6,104.946,410.6,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M407.445,104.871c0-.076.353-.137.788-.137s.789.061.789.137-.353.136-.789.136S407.445,104.946,407.445,104.871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,102.7c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,102.7,406.462,102.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,99.549c.075,0,.136.353.136.789s-.061.788-.136.788-.137-.353-.137-.788S406.386,99.549,406.462,99.549Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,96.4c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,96.4,406.462,96.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,93.245c.075,0,.136.352.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,93.245,406.462,93.245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,90.092c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.352-.137-.788S406.386,90.092,406.462,90.092Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,86.94c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,86.94,406.462,86.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,83.787c.075,0,.136.353.136.788s-.061.789-.136.789-.137-.353-.137-.789S406.386,83.787,406.462,83.787Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,80.635c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,80.635,406.462,80.635Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,77.483c.075,0,.136.352.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,77.483,406.462,77.483Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,74.33c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,74.33,406.462,74.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,71.178c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,71.178,406.462,71.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,68.025c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.352-.137-.788S406.386,68.025,406.462,68.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,64.873c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,64.873,406.462,64.873Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,61.72c.075,0,.136.353.136.788s-.061.789-.136.789-.137-.353-.137-.789S406.386,61.72,406.462,61.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,58.568c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,58.568,406.462,58.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,55.416c.075,0,.136.352.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,55.416,406.462,55.416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,52.263c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.352-.137-.788S406.386,52.263,406.462,52.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.462,49.111c.075,0,.136.353.136.788s-.061.788-.136.788-.137-.353-.137-.788S406.386,49.111,406.462,49.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M409.223,48.72c0,.075-.353.136-.788.136s-.789-.061-.789-.136.353-.137.789-.137S409.223,48.644,409.223,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M412.375,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S412.375,48.644,412.375,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M415.528,48.72c0,.075-.353.136-.789.136s-.788-.061-.788-.136.353-.137.788-.137S415.528,48.644,415.528,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M418.68,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S418.68,48.644,418.68,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M421.832,48.72c0,.075-.352.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S421.832,48.644,421.832,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M424.985,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.352-.137.788-.137S424.985,48.644,424.985,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M428.137,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S428.137,48.644,428.137,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M431.29,48.72c0,.075-.353.136-.788.136s-.789-.061-.789-.136.353-.137.789-.137S431.29,48.644,431.29,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M434.442,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S434.442,48.644,434.442,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M437.594,48.72c0,.075-.352.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S437.594,48.644,437.594,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M440.747,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.352-.137.788-.137S440.747,48.644,440.747,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M443.9,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S443.9,48.644,443.9,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M447.052,48.72c0,.075-.353.136-.788.136s-.789-.061-.789-.136.353-.137.789-.137S447.052,48.644,447.052,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M450.2,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S450.2,48.644,450.2,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.356,48.72c0,.075-.352.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S453.356,48.644,453.356,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M456.509,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S456.509,48.644,456.509,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M459.661,48.72c0,.075-.353.136-.788.136s-.788-.061-.788-.136.353-.137.788-.137S459.661,48.644,459.661,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,48.921c-.035,0-.067-.075-.091-.2l.091.09a3.264,3.264,0,0,1-.587.046c-.436,0-.788-.061-.788-.136s.352-.137.788-.137a3.174,3.174,0,0,1,.587.046l.1.02-.014.071C462.679,48.846,462.647,48.921,462.613,48.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,52.073c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,52.073,462.613,52.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,55.225c-.076,0-.137-.352-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,55.225,462.613,55.225Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,58.378c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.352.136.788S462.688,58.378,462.613,58.378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,61.53c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,61.53,462.613,61.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,64.683c-.076,0-.137-.353-.137-.788s.061-.789.137-.789.136.353.136.789S462.688,64.683,462.613,64.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,67.835c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,67.835,462.613,67.835Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,70.988c-.076,0-.137-.353-.137-.789s.061-.788.137-.788.136.353.136.788S462.688,70.988,462.613,70.988Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,74.14c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.352.136.788S462.688,74.14,462.613,74.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,77.292c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,77.292,462.613,77.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,80.445c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.352.136.788S462.688,80.445,462.613,80.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,83.6c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,83.6,462.613,83.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,86.75c-.076,0-.137-.353-.137-.789s.061-.788.137-.788.136.353.136.788S462.688,86.75,462.613,86.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,89.9c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.352.136.788S462.688,89.9,462.613,89.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,93.054c-.076,0-.137-.352-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,93.054,462.613,93.054Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,96.207c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.352.136.788S462.688,96.207,462.613,96.207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,99.359c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.353.136.788S462.688,99.359,462.613,99.359Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.613,102.512c-.076,0-.137-.353-.137-.788s.061-.788.137-.788.136.352.136.788S462.688,102.512,462.613,102.512Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.159,
    height: 4.159,
    transform: "translate(460.533 102.222)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.159,
    height: 4.159,
    transform: "translate(404.382 102.791)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.159,
    height: 4.159,
    transform: "translate(460.533 46.235)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.159,
    height: 4.159,
    transform: "translate(404.382 46.64)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609.111 45.57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M696.23,124.27h-7.4L672.67,101.754V86.977s-11.444-.7-10.1,18.648-.11,14.423-.11,14.423-24.3.095-26.318,2.2c-1.469,1.535-2.131,25.671-2.387,38.76-.125,6.592,3.914,12.719,10.044,14.275a10.5,10.5,0,0,0,2.616.352c6.059,0,37.025-4.927,37.025-4.927H696.23Z",
    transform: "translate(-633.756 -86.974)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.437 33.241)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M681.164,102.072l-4.554,50.637H663.932V103.091Z",
    transform: "translate(-663.932 -102.072)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.744 468.525)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M796.744,468.785c0,.144-162.982.26-363.982.26-201.071,0-364.018-.116-364.018-.26s162.946-.26,364.018-.26C633.762,468.525,796.744,468.641,796.744,468.785Z",
    transform: "translate(-68.744 -468.525)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M344.533,349.941c-.988-.216-9.063,37.7-8.01,52.448s8.01,66.006,8.01,66.006h82.924s10.37-49.856,8.52-64.953-11.7-54.807-11.7-54.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M333.927,278.248,322.079,224.9l-.686-8.832s-2.713-19.8-2.732-21.739c-.021-2.236-1.1-2.764-1.928-2.7-1.284.1-2.177,1.692-2.218,3.612-.014.664.184,11.142.184,11.142a24.8,24.8,0,0,0-2.06-2.806c-1.572-1.945-5.223-3.026-8.957-2.865s-4.764.536-4.769,1.989a1.849,1.849,0,0,0,.748,1.4,3.659,3.659,0,0,0,2.472.822c5.982-.175,7.628,3,7.628,3l.09,1.156s-3.666-2.557-6.549-1.429a3.5,3.5,0,0,0-1.148.726,4.681,4.681,0,0,0-3.98,7.027,1.947,1.947,0,0,0,1.893,1.153,2.5,2.5,0,0,0,1.052-.655,3.8,3.8,0,0,1,.528-.4l.7,3.2s1.967,7.108,2.473,10.3l3.169,52.877a13.135,13.135,0,0,0,14.128,12.309h0A13.135,13.135,0,0,0,333.927,278.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M320.349,224.2a2.727,2.727,0,0,1-2.833-1.445c-.6-.966-.862-2.107-1.395-3.114-1.592-3.01-5.377-4.413-6.823-7.5-.2-.43-.316-1.023.061-1.312.35-.267.849-.064,1.236.145l9.927,5.354"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M320.522,216.327a4.5,4.5,0,0,0-1.014-.689c-.673-.407-1.657-.977-2.879-1.669l-4.309-2.4-1.25-.687a2.235,2.235,0,0,0-1.631-.444.953.953,0,0,0-.641.853,1.958,1.958,0,0,0,.174.907,7.4,7.4,0,0,0,.867,1.419c1.385,1.76,3.16,2.856,4.449,4.138a8.49,8.49,0,0,1,1.585,1.987c.382.695.625,1.427.919,2.078a3.969,3.969,0,0,0,2.317,2.436,1.428,1.428,0,0,0,1.24-.059,3.284,3.284,0,0,1-1.156-.177,3.847,3.847,0,0,1-1.982-2.377c-.258-.638-.474-1.384-.867-2.152a8.75,8.75,0,0,0-1.639-2.158c-1.324-1.353-3.081-2.475-4.356-4.108a6.864,6.864,0,0,1-.788-1.279c-.192-.427-.172-.863.076-.909.262-.092.719.153,1.142.386s.848.45,1.26.667l4.374,2.281c1.25.641,2.267,1.15,2.976,1.489A4.536,4.536,0,0,0,320.522,216.327Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M309.992,209.135a4.664,4.664,0,0,0-.709-2.009,3.587,3.587,0,0,0-1.837-1.3,9.178,9.178,0,0,0-2.834-.378,14.648,14.648,0,0,1-2.961-.226,4.729,4.729,0,0,1-2.213-1.074,1.848,1.848,0,0,1-.607-1.542,1.1,1.1,0,0,1,.191-.578c.039.011-.027.218-.03.586a1.741,1.741,0,0,0,.646,1.318,4.671,4.671,0,0,0,2.092.916,16.2,16.2,0,0,0,2.889.185,8.949,8.949,0,0,1,2.955.432,3.765,3.765,0,0,1,1.952,1.5,3.334,3.334,0,0,1,.523,1.571A1.148,1.148,0,0,1,309.992,209.135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M314.542,194.5a11.73,11.73,0,0,1,.053,2.083c0,1.429,0,3.132,0,5.015.028,1.883.054,3.586.076,5.015a11.6,11.6,0,0,1-.022,2.083,9.37,9.37,0,0,1-.272-2.069c-.1-1.284-.182-3.061-.2-5.026s.038-3.742.121-5.028A9.384,9.384,0,0,1,314.542,194.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M307.653,211.522a2.536,2.536,0,0,1-.611-.229,1.931,1.931,0,0,0-1.61-.06,1.037,1.037,0,0,0-.533.877,5.51,5.51,0,0,0,.113,1.353,2.334,2.334,0,0,1-.231,1.642,1.986,1.986,0,0,1-1.586.847,2.261,2.261,0,0,1-1.648-.692,2.833,2.833,0,0,1-.79-1.449,9.134,9.134,0,0,1,.013-2.681,5.391,5.391,0,0,1,.513-1.73c.211-.38.409-.53.421-.515.028.025-.119.205-.275.583a6.408,6.408,0,0,0-.368,1.7,9.847,9.847,0,0,0,.071,2.572,2.236,2.236,0,0,0,2.048,1.8,1.6,1.6,0,0,0,1.262-.655,2,2,0,0,0,.191-1.371,5.464,5.464,0,0,1-.075-1.447,1.34,1.34,0,0,1,.742-1.093,2.025,2.025,0,0,1,1.811.175C307.484,211.354,307.665,211.5,307.653,211.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M301.716,214.94c.019,0,.079.218-.052.592a1.813,1.813,0,0,1-1.2,1.089,2.417,2.417,0,0,1-2.3-.684,3.957,3.957,0,0,1-1.054-2.745,4.789,4.789,0,0,1,.865-2.807,4.577,4.577,0,0,1,1.853-1.52,4.331,4.331,0,0,1,1.56-.386,1.237,1.237,0,0,1,.585.051,7.552,7.552,0,0,0-2.017.6,4.514,4.514,0,0,0-1.666,1.472,4.569,4.569,0,0,0-.765,2.584,3.68,3.68,0,0,0,.912,2.483,2.145,2.145,0,0,0,1.957.667,1.717,1.717,0,0,0,1.128-.869C301.679,215.151,301.68,214.937,301.716,214.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M309.006,221.864a1.706,1.706,0,0,1,1,0,3.933,3.933,0,0,1,2.2,1.3l-.351.107a11.622,11.622,0,0,1,.217-1.4,8.958,8.958,0,0,1,2.111-4.4,22.7,22.7,0,0,0-1.706,4.484c-.1.469-.176.927-.226,1.351l-.056.47-.3-.363a4.117,4.117,0,0,0-1.951-1.308C309.374,221.93,309.005,221.919,309.006,221.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M308.615,204.036c.1.047-.3.8-1.214,1.207a1.852,1.852,0,0,1-1.709.1c.011-.121.748-.113,1.54-.476C308.031,204.517,308.518,203.963,308.615,204.036Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M428.969,232.942c4.339,0,14.772,12.325,16.591,31.059.833,8.576,5.131,43.712,7.21,60.6a16.854,16.854,0,0,1-6.86,15.7c-11.229,8.154-33.7,20.98-63.6,20.624L364.2,345.73l58.8-24.779.032-1.34,2.564-2.808-7.338-44.995S411.4,232.943,428.969,232.942Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M413.666,153.791c.222,6.086,8.334,9.774,8.23,15.862-.045,2.613-1.666,4.959-1.984,7.553-.427,3.487,1.521,6.779,2.241,10.217,1.483,7.084-2.637,14.557-8.748,18.435s-13.782,4.618-20.953,3.637"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M364.677,152.3c.241,3.267-1.916,6.185-4.09,8.636s-4.593,5.005-5.062,8.246c-.833,5.746,4.792,11.08,3.632,16.768-.622,3.049-3.118,5.5-3.563,8.577-.43,2.978,1.166,5.894,3.145,8.161s4.27,1.936,6.02,4.384a24.614,24.614,0,0,0,7.592,6.748c6.3,3.452,13.87-1.542,16.911-2.439"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M414.887,157.295c.085-2.963-2.655-5.252-5.413-6.337s-5.824-1.495-8.282-3.149c-2.177-1.466-3.64-3.751-5.483-5.619a18.244,18.244,0,0,0-30.684,8.37c-1.059,4.22-.336,9.208,2.99,12.012,3.86,3.254,9.583,2.532,14.529,1.519s10.545-2.01,14.674.894c2.491,1.752,3.918,4.6,5.44,7.238s3.434,5.33,6.313,6.321,6.788-.721,6.9-3.763"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M375.5,226.307c-.04-6.8-.08-13.423-.083-13.388,0,0-10.8-1.817-13.006-15.918-1.1-7.012-.72-18.5-.108-27.9.552-8.455,6.177-18.818,14.6-17.908l26.3,6.708a4.958,4.958,0,0,1,4.424,5.039h0l-2.407,63.838a14.864,14.864,0,0,1-15.148,14.3h0A14.865,14.865,0,0,1,375.5,226.307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M366.783,177.158a1.808,1.808,0,0,0,1.739,1.828,1.729,1.729,0,0,0,1.867-1.626,1.808,1.808,0,0,0-1.737-1.828A1.73,1.73,0,0,0,366.783,177.158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M364.787,175.087c.224.237,1.6-.774,3.541-.764,1.943-.019,3.369.985,3.58.747.1-.105-.123-.531-.744-.985a4.964,4.964,0,0,0-2.865-.89,4.766,4.766,0,0,0-2.819.9C364.881,174.556,364.677,174.982,364.787,175.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M385.67,177.646a1.808,1.808,0,0,0,1.739,1.828,1.73,1.73,0,0,0,1.867-1.626,1.808,1.808,0,0,0-1.738-1.828A1.729,1.729,0,0,0,385.67,177.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M383.907,175.493c.224.236,1.6-.774,3.542-.765,1.943-.019,3.368.985,3.58.748.1-.106-.121-.531-.745-.985a4.952,4.952,0,0,0-2.865-.891,4.771,4.771,0,0,0-2.819.9C384,174.961,383.8,175.387,383.907,175.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M376.816,189.9a12.916,12.916,0,0,0-3.158-.577c-.5-.052-.967-.152-1.05-.491a2.533,2.533,0,0,1,.335-1.472q.705-1.8,1.478-3.779c2.051-5.38,3.538-9.8,3.32-9.886s-2.057,4.215-4.108,9.6c-.494,1.327-.967,2.591-1.416,3.8a2.875,2.875,0,0,0-.262,1.949,1.25,1.25,0,0,0,.815.728,3.4,3.4,0,0,0,.844.119A12.638,12.638,0,0,0,376.816,189.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M375.421,212.919a35.857,35.857,0,0,0,18.889-4.993c-.159.033-5.2,9.8-18.706,8.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M377.628,194.593a3.509,3.509,0,0,1,3.145-1.295,3.2,3.2,0,0,1,2.208,1.191,2.028,2.028,0,0,1,.149,2.318,2.353,2.353,0,0,1-2.552.64,7.364,7.364,0,0,1-2.483-1.49,2.149,2.149,0,0,1-.554-.576.65.65,0,0,1,0-.724"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M382.538,191.261c-.317-.019-.325,2.093-2.136,3.587s-4.058,1.258-4.075,1.553c-.03.133.5.411,1.45.439a5.26,5.26,0,0,0,3.4-1.176,4.582,4.582,0,0,0,1.655-3.008C382.917,191.773,382.682,191.249,382.538,191.261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M383.04,172.085c.191.529,2.134.283,4.415.563,2.287.234,4.126.907,4.43.433.136-.227-.184-.725-.927-1.239a7.739,7.739,0,0,0-6.739-.759C383.381,171.419,382.958,171.834,383.04,172.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M365.515,169.459c.341.443,1.682-.013,3.294-.031,1.61-.074,2.975.3,3.29-.158.138-.224-.076-.667-.671-1.086a4.77,4.77,0,0,0-5.305.152C365.553,168.789,365.365,169.243,365.515,169.459Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M409.17,205.059c-3.877.781-4.222-1.191-7.119-3.884a12.728,12.728,0,0,1-3.895-10.739c.438-3.462,2.3-6.984,1.1-10.26-1.587-4.333-7.659-5.665-9.271-9.988-.936-2.513-.1-5.452-1.157-7.914-1-2.315-3.434-3.649-5.806-4.506s-4.913-1.449-6.9-3-3.232-4.468-1.948-6.638a133.614,133.614,0,0,1,30.8,7.484c2.3.859,4.717,1.892,6.077,3.936,1.439,2.164,1.37,4.959,1.249,7.555q-.887,18.984-1.772,37.969"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M418.036,176.3a10.816,10.816,0,0,1,20.472-3.745c1.96,3.981,1.282,8.825-.547,12.868-2.174,4.8-6.626,9.193-11.893,8.954-4.955-.225-8.945-4.577-10.373-9.328s-.852-9.843-.262-14.768"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M420.8,195.609a2.486,2.486,0,0,0,.739-.818,6.93,6.93,0,0,0,1.051-2.821,13.51,13.51,0,0,0-.127-4.453c-.287-1.659-.846-3.4-1.253-5.242a13.1,13.1,0,0,1-.308-5.215c.289-1.57,1.027-2.9,1.352-4.143a5.355,5.355,0,0,0,.084-3.014c-.222-.7-.527-.982-.548-.962-.047.028.178.355.315,1.021a5.578,5.578,0,0,1-.27,2.828,35.6,35.6,0,0,0-1.493,4.162,13.087,13.087,0,0,0,.263,5.457c.416,1.882.99,3.613,1.3,5.212a14.019,14.019,0,0,1,.255,4.289A8.864,8.864,0,0,1,420.8,195.609Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M421,178.682a6.851,6.851,0,0,0,2.161,2.116,12.367,12.367,0,0,0,13.932.244A6.862,6.862,0,0,0,439.328,179c-.075-.079-.881.753-2.463,1.665a12.879,12.879,0,0,1-13.461-.236C421.855,179.465,421.078,178.6,421,178.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M421.7,180.891a6.436,6.436,0,0,0,1.194,2.214,15.424,15.424,0,0,0,10.213,6.142,6.45,6.45,0,0,0,2.515.017,23.348,23.348,0,0,0-2.44-.449,17.541,17.541,0,0,1-9.942-5.979A23.868,23.868,0,0,0,421.7,180.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M418.152,200.328c.008.007.06-.052.154-.175a5.029,5.029,0,0,0,.389-.564,7.473,7.473,0,0,0,.928-2.465,8.662,8.662,0,0,0-.226-4.162,7.963,7.963,0,0,0-3.28-4.412c-1.673-1.179-3.85-2-5.234-3.876a4.233,4.233,0,0,1-.765-3.31,18.82,18.82,0,0,1,1.226-3.658,10.52,10.52,0,0,0-.181-8.416,9.223,9.223,0,0,0-2.861-3.553,11.161,11.161,0,0,0-4.323-1.792c-1.527-.348-3.049-.55-4.463-.977a8.7,8.7,0,0,1-3.737-2.044,6.206,6.206,0,0,1-1.621-3.7,31.635,31.635,0,0,0-.664-4.1,14.13,14.13,0,0,0-3.8-6.669,11.145,11.145,0,0,0-5.988-2.971,8.9,8.9,0,0,0-5.449.825,8.619,8.619,0,0,0-3.152,2.729,7.3,7.3,0,0,0-1.1,2.392,3.759,3.759,0,0,0-.137.907,8.962,8.962,0,0,1,1.436-3.158,8.492,8.492,0,0,1,8.336-3.262,10.747,10.747,0,0,1,5.7,2.908,13.68,13.68,0,0,1,3.608,6.442,31.736,31.736,0,0,1,.631,4.042,6.793,6.793,0,0,0,1.773,4.037,9.262,9.262,0,0,0,3.993,2.208c1.481.448,3.009.649,4.5.991a10.6,10.6,0,0,1,4.1,1.685,8.626,8.626,0,0,1,2.674,3.313,9.952,9.952,0,0,1,.2,7.957,19.047,19.047,0,0,0-1.231,3.778,4.767,4.767,0,0,0,.889,3.694c1.538,2.022,3.779,2.809,5.4,3.936a7.62,7.62,0,0,1,3.2,4.154,8.589,8.589,0,0,1,.32,4.017A9.448,9.448,0,0,1,418.152,200.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M417.208,160.974a1.552,1.552,0,0,0,.174-.65,3.036,3.036,0,0,0-.468-1.872,4.789,4.789,0,0,0-2.357-1.95,7.421,7.421,0,0,0-4.048-.134c-1.478.28-3.009.87-4.686,1.2a6.241,6.241,0,0,1-5.1-.8c-1.5-1.139-2.25-3.112-3.019-5.073a21.048,21.048,0,0,0-3.257-5.805,19.5,19.5,0,0,0-10.667-6.9,11.182,11.182,0,0,0-5.632.148,8.761,8.761,0,0,0-4.125,2.666,6.51,6.51,0,0,0-1.56,3.735,6.408,6.408,0,0,0,.466,3.022,4.869,4.869,0,0,0,1.061,1.61,2,2,0,0,0,.52.423,6.833,6.833,0,0,1-1.357-2.123,6.313,6.313,0,0,1-.345-2.9,6.187,6.187,0,0,1,1.549-3.484,8.376,8.376,0,0,1,3.939-2.459,10.744,10.744,0,0,1,5.362-.082,19.133,19.133,0,0,1,10.3,6.728,20.641,20.641,0,0,1,3.176,5.642c.78,1.945,1.552,4.029,3.24,5.305a5.344,5.344,0,0,0,2.782,1.045,9.521,9.521,0,0,0,2.759-.194c1.739-.362,3.246-.973,4.676-1.27a7.168,7.168,0,0,1,3.838.03,4.611,4.611,0,0,1,2.274,1.753,3.061,3.061,0,0,1,.547,1.737C417.258,160.745,417.171,160.965,417.208,160.974Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M430.208,233.143l-24.987-6.363h-29.8s-15.446.888-24.046,8.48a18.973,18.973,0,0,0-4.686,7.666L333.446,273.24l-6.8-38.012-23.781,3.378,3.838,65.412a32.117,32.117,0,0,0,25.321,28.218l13.53-15.213c1.561,12.408,2.946,23.052,3.086,22.912.333-.333,74.075-4.8,74.075-4.8l-7.465-25.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M335.709,148.5a17.049,17.049,0,1,0-24.474,15.171c-.021,2.02-.045,4.3-.045,4.3l14.942.156s.116-2.413.172-4.568A17.042,17.042,0,0,0,335.709,148.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M320.73,168s0-.071.019-.21l.076-.614c.071-.539.176-1.335.337-2.356s.376-2.269.717-3.7a25.281,25.281,0,0,1,1.6-4.728,16.29,16.29,0,0,1,1.429-2.537,3.139,3.139,0,0,1,1.176-1.034,1.761,1.761,0,0,1,1.619.069,1.163,1.163,0,0,1,.532.681,1.189,1.189,0,0,1-.08.874,2.424,2.424,0,0,1-1.329,1.121,4.664,4.664,0,0,1-3.541-.288,4.727,4.727,0,0,1-2.378-2.87,3.57,3.57,0,0,1-.08-1.968,1.532,1.532,0,0,1,1.561-1.168,1.1,1.1,0,0,1,.862.61,1.548,1.548,0,0,1,.126,1.053,3.334,3.334,0,0,1-1.216,1.681,5.088,5.088,0,0,1-3.986,1.112,4.431,4.431,0,0,1-3.271-2.492,2.573,2.573,0,0,1-.094-2.066,1.3,1.3,0,0,1,.756-.747,1.28,1.28,0,0,1,1.048.108,1.69,1.69,0,0,1,.712.756,2.658,2.658,0,0,1,.25.984,4.908,4.908,0,0,1-.28,1.946,5.072,5.072,0,0,1-2.433,2.834,5.163,5.163,0,0,1-3.533.448,2.7,2.7,0,0,1-1.526-.83,1.319,1.319,0,0,1-.077-1.643,1.112,1.112,0,0,1,.77-.366,1.607,1.607,0,0,1,.811.166,2.467,2.467,0,0,1,1.032,1.181c.419.929.753,1.831,1.093,2.693,1.327,3.45,2.265,6.292,2.892,8.26.313.985.545,1.753.7,2.274q.109.383.171.6c.037.134.051.205.051.205s-.027-.067-.072-.2-.109-.336-.191-.588c-.171-.526-.419-1.286-.736-2.262-.651-1.96-1.61-4.792-2.954-8.232-.341-.854-.685-1.767-1.1-2.675a2.317,2.317,0,0,0-.961-1.1,1.022,1.022,0,0,0-1.291,1.579,2.527,2.527,0,0,0,1.429.764,4.99,4.99,0,0,0,3.4-.44,4.881,4.881,0,0,0,2.334-2.729,4.723,4.723,0,0,0,.265-1.864,1.853,1.853,0,0,0-.857-1.576,1.071,1.071,0,0,0-.882-.093,1.1,1.1,0,0,0-.634.634,2.372,2.372,0,0,0,.094,1.9,4.225,4.225,0,0,0,3.116,2.37,4.88,4.88,0,0,0,3.819-1.066,3.146,3.146,0,0,0,1.146-1.566,1.337,1.337,0,0,0-.107-.911.893.893,0,0,0-.7-.5,1.2,1.2,0,0,0-.851.265,1.474,1.474,0,0,0-.494.758,3.377,3.377,0,0,0,.078,1.852,4.5,4.5,0,0,0,5.662,3.043,2.252,2.252,0,0,0,1.232-1.026,1.006,1.006,0,0,0-.381-1.329,1.59,1.59,0,0,0-1.458-.066,2.985,2.985,0,0,0-1.116.979,16.143,16.143,0,0,0-1.424,2.5,25.429,25.429,0,0,0-1.618,4.694c-.35,1.423-.575,2.667-.75,3.684s-.288,1.8-.375,2.349c-.042.262-.074.465-.1.611S320.73,168,320.73,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M324.953,170.882l-12.829-.134a.962.962,0,0,1-.953-.973h0a.964.964,0,0,1,.973-.953l12.83.134a.963.963,0,0,1,.952.973h0A.962.962,0,0,1,324.953,170.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M324.945,171.723l-12.83-.134a.963.963,0,1,0-.02,1.926l1.408.014,1.831,3.576a1.239,1.239,0,0,0,1.088.673l4.585.048a1.237,1.237,0,0,0,1.108-.662l1.852-3.525.958.01a.963.963,0,1,0,.02-1.926Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M307.821,137.344a12.57,12.57,0,0,1,3.438-2.234,9.062,9.062,0,0,1,2.635-.736c.646-.06,1.013.006,1.043.142.07.311-1.227.756-2.98,1.9a14.019,14.019,0,0,0-6.535,13.7c.214,2.083.684,3.371.4,3.511-.125.063-.407-.18-.767-.72a9.064,9.064,0,0,1-1.086-2.511,12.513,12.513,0,0,1-.428-4.078,13.258,13.258,0,0,1,1.245-4.916"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M319.029,135.294c-1.081-.021-2.031-.326-2.136-.9-.044-.284.159-.584.552-.816a3.42,3.42,0,0,1,3.221.05c.385.244.579.551.526.833"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M321.873,177.466c-.016.031-.337-.12-.879-.281a7.14,7.14,0,0,0-4.335.08c-.535.182-.851.344-.867.313a2.612,2.612,0,0,1,.816-.452,6.252,6.252,0,0,1,4.432-.082A2.619,2.619,0,0,1,321.873,177.466Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M323.994,173.682c0,.058-2.32.081-5.181.051s-5.18-.1-5.179-.159,2.32-.08,5.181-.05S323.995,173.625,323.994,173.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M323.175,175.2a7.3,7.3,0,0,1-1.264.115c-.783.041-1.865.075-3.061.079s-2.279-.021-3.062-.056a7.168,7.168,0,0,1-1.265-.107,8.093,8.093,0,0,1,1.268-.041l3.058-.005,3.058-.018A7.937,7.937,0,0,1,323.175,175.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M348.339,290.986a4.009,4.009,0,0,1-.75-.924,10.3,10.3,0,0,1-1.334-2.967,18.66,18.66,0,0,1,.632-10.6c1.34-3.971,3.093-7.31,4.068-9.84.506-1.258.874-2.292,1.106-3.015a5.745,5.745,0,0,1,.4-1.114,4.757,4.757,0,0,1-.2,1.17,28.727,28.727,0,0,1-.957,3.091c-.9,2.584-2.6,5.961-3.917,9.87a19.278,19.278,0,0,0-.77,10.343A15.337,15.337,0,0,0,348.339,290.986Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M417.4,265.165a2.143,2.143,0,0,1,.141.515l.3,1.494c.254,1.376.6,3.24,1.016,5.51.831,4.658,1.937,11.1,3.1,18.225s2.148,13.591,2.791,18.28c.324,2.344.554,4.246.7,5.562.054.611.1,1.113.134,1.519a2.121,2.121,0,0,1,.012.533,2.015,2.015,0,0,1-.116-.521c-.062-.4-.138-.9-.231-1.505-.215-1.382-.5-3.255-.859-5.535-.764-4.738-1.8-11.156-2.941-18.249s-2.181-13.508-2.947-18.247c-.351-2.282-.639-4.155-.852-5.538-.083-.608-.151-1.107-.207-1.51A2.023,2.023,0,0,1,417.4,265.165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M332.791,291.962a17.785,17.785,0,0,1,.171-2.786c.146-1.713.315-4.08.385-6.7s.023-4.993-.033-6.711a17.738,17.738,0,0,1-.025-2.791,12.828,12.828,0,0,1,.393,2.769,62.7,62.7,0,0,1-.354,13.472A12.838,12.838,0,0,1,332.791,291.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M434.409,323.44c-.083.017-.231-.657-.706-1.634a8.571,8.571,0,0,0-6.5-4.812c-1.073-.169-1.761-.114-1.769-.2a3.636,3.636,0,0,1,1.812-.167,7.958,7.958,0,0,1,6.8,5.029A3.642,3.642,0,0,1,434.409,323.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M428.917,326.392a13.788,13.788,0,0,0-6.047-5.583,7.942,7.942,0,0,1,6.047,5.583Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M410.5,326.407c-.051-.14,2.788-1.3,6.24-2.828s6.223-2.847,6.291-2.714a51.444,51.444,0,0,1-12.531,5.542Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M313.255,284.247s14.354,68.392,14.354,67.5c0-.816,72.465,3.108,85.435,3.678l2.7-.657L436.2,335.933l-23.532-1.9-8.416-48.121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M404.25,285.915c.142-.024,2.829,15.371,6,34.38s5.632,34.446,5.49,34.47-2.829-15.368-6-34.384S404.108,285.938,404.25,285.915Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M404.514,285.949a2.881,2.881,0,0,1-.519.512,13.707,13.707,0,0,0-1.495,1.422c-.251.335-.59.79-.412,1.271.141.55.215,1.132.337,1.766.225,1.274.478,2.713.757,4.3,1.092,6.426,2.586,15.208,4.235,24.91,1.592,9.716,3.032,18.507,4.086,24.94.491,3.152.891,5.722,1.179,7.567.122.855.22,1.54.295,2.062a3.8,3.8,0,0,1,.067.725,3.905,3.905,0,0,1-.171-.708l-.391-2.045-1.342-7.54c-1.093-6.427-2.586-15.209-4.237-24.915-1.591-9.712-3.031-18.5-4.084-24.935l-.681-4.311c-.107-.628-.172-1.238-.292-1.756a1.608,1.608,0,0,1,.5-1.459,11.235,11.235,0,0,1,1.584-1.373A5.622,5.622,0,0,1,404.514,285.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M401.864,288.444a5.8,5.8,0,0,1-.893.032l-2.56-.012L389,288.333l-31.054-.548-31.058-.519-9.412-.141-2.56-.056a5.792,5.792,0,0,1-.892-.055,5.674,5.674,0,0,1,.893-.05l2.559-.042c2.223-.03,5.44-.031,9.415-.024,7.95.024,18.933.149,31.065.367s23.106.476,31.052.7l9.411.3,2.557.11A5.807,5.807,0,0,1,401.864,288.444Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M412.607,335.983A7.282,7.282,0,0,1,414,335.97l3.8.152c3.217.15,7.681.392,12.667.693l.645.039-.492.419-.921.782c-4.018,3.413-7.675,6.48-10.338,8.68l-3.172,2.585a8.178,8.178,0,0,1-1.209.893,8.4,8.4,0,0,1,1.078-1.048l3.065-2.711c2.6-2.272,6.221-5.383,10.239-8.8l.921-.781.152.457c-4.985-.31-9.445-.613-12.657-.856l-3.793-.313A7.505,7.505,0,0,1,412.607,335.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M349.56,353.842h0l-.928-11.136a3.47,3.47,0,0,1,3.977,3.579v-6.894s4.243-.928,5.171,4.641a39.308,39.308,0,0,0,2.255,8.577l2.252,1.233-2.121-12.86s4.508.4,5.3,4.64a41.646,41.646,0,0,0,2,7.223l7.122,1.991s-4.088-3.645-3.69-4.838.133-1.119.928-1.289a7.547,7.547,0,0,1,3.8,1c1.3.69,8.8,5.127,8.8,5.127v5.5s-17.46,1.264-21.4.529l-7.637-1.768A8.091,8.091,0,0,1,349.56,353.842Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M366.244,317.263a4.848,4.848,0,1,1-5.634-4.513A5.119,5.119,0,0,1,366.244,317.263Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.52,316.514a12.951,12.951,0,0,1,9.094.273,9.323,9.323,0,0,1,5.525,6.984,4.436,4.436,0,0,1-.152,2.124,2.367,2.367,0,0,1-1.453,1.482,2.767,2.767,0,0,1-2.92-1.393,17.689,17.689,0,0,1-1.292-3.218,10.148,10.148,0,0,0-9.049-6.277l.473.128"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M372.917,230.539c.6-1.88.06-3.9-.271-5.847s-.375-4.167.948-5.63,3.494-1.636,5.452-1.721l24.207-1.052c1.651-.071,3.564-.031,4.6,1.258a3.55,3.55,0,0,1,.851,2.974c-1.244,4.61-.855,8.492.954,11.739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M405.713,228.229a7.064,7.064,0,0,1-1.059.891,28.233,28.233,0,0,1-3.188,2.015,31.24,31.24,0,0,1-11.858,3.619,27.97,27.97,0,0,1-6.865-.133A16.22,16.22,0,0,1,377.4,232.9a9.815,9.815,0,0,1-2.943-2.381,5.729,5.729,0,0,1-.594-.841c-.12-.2-.176-.312-.161-.322a11.9,11.9,0,0,0,3.87,3.218,16.624,16.624,0,0,0,5.241,1.578,28.979,28.979,0,0,0,6.744.088,33.115,33.115,0,0,0,11.737-3.426C404.112,229.381,405.654,228.145,405.713,228.229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M389.189,234.833a14.293,14.293,0,0,1-.629-2.666c-.322-1.658-.733-3.954-1.154-6.5-.2-1.262-.394-2.465-.573-3.588a6.414,6.414,0,0,1,.1-3.032,2.958,2.958,0,0,1,1.27-1.618c.438-.24.724-.228.726-.2.012.043-.25.1-.615.372a2.97,2.97,0,0,0-1.03,1.56,6.437,6.437,0,0,0,.023,2.845c.192,1.121.4,2.32.613,3.578.421,2.542.774,4.847,1,6.521A14.323,14.323,0,0,1,389.189,234.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M401.77,231a9.717,9.717,0,0,1-.454-2.2c-.215-1.366-.476-3.258-.732-5.35-.273-2.081-.422-4.022-.618-5.341a2.019,2.019,0,0,0-.755-1.286c-.3-.209-.519-.226-.513-.269-.005-.026.237-.088.618.1a2.1,2.1,0,0,1,1.007,1.37c.306,1.4.5,3.266.778,5.367.256,2.093.459,3.992.58,5.369A9.53,9.53,0,0,1,401.77,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M378.739,217.361a5.367,5.367,0,0,0-1.628,1.362,5.2,5.2,0,0,0-.89,2.092,10.812,10.812,0,0,0-.084,2.848c.187,2.056.361,3.938.446,5.294a9.377,9.377,0,0,1,.038,2.211,9.3,9.3,0,0,1-.4-2.174c-.179-1.353-.41-3.21-.6-5.292a10.214,10.214,0,0,1,.135-2.985,5.181,5.181,0,0,1,1.07-2.222A2.641,2.641,0,0,1,378.739,217.361Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M622.542,441c-7.845-4.548-12.042-15.129-12.355-23.788s3.293-17.694,10.394-22.659c7.481-5.229,18.134-5.135,25.82-.213s12.188,14.212,11.841,23.333a30.942,30.942,0,0,1-12.672,23.238"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M635.063,441.834a10.252,10.252,0,0,1-.145-1.981c-.04-1.417-.092-3.23-.153-5.4-.117-4.56-.3-10.857-.6-17.808s-.681-13.242-.965-17.8c-.13-2.168-.238-3.979-.322-5.393a10.2,10.2,0,0,1-.029-1.986,10.406,10.406,0,0,1,.314,1.961c.156,1.268.347,3.105.555,5.378.417,4.547.874,10.84,1.182,17.8s.4,13.268.385,17.833c-.007,2.283-.036,4.131-.08,5.407A10.29,10.29,0,0,1,635.063,441.834Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M612.508,415.248c-.017.2-1.268.265-2.794.14s-2.751-.391-2.735-.594,1.268-.264,2.795-.139S612.525,415.046,612.508,415.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M612.937,407.479c-.083.186-1.162-.113-2.411-.667s-2.194-1.154-2.112-1.339,1.161.113,2.411.667S613.019,407.293,612.937,407.479Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M616.935,401.711c-.1.169-1.319-.4-2.58-1.449s-2.052-2.129-1.906-2.264,1.151.688,2.375,1.7S617.046,401.536,616.935,401.711Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M620.955,396.27c-.185.082-.767-.826-1.3-2.029s-.812-2.245-.626-2.327.767.827,1.3,2.03S621.141,396.188,620.955,396.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M627.263,392.409c-.181.085-.807-.882-1.222-2.223s-.452-2.492-.256-2.524.554,1.017.958,2.306S627.45,392.323,627.263,392.409Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M637.789,388.057c.191.068.074.894-.261,1.845s-.763,1.667-.955,1.6-.074-.894.261-1.845S637.6,387.99,637.789,388.057Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M645.6,391.408c.138.149-.363.836-1.118,1.535s-1.48,1.145-1.618,1,.363-.836,1.119-1.535S645.458,391.259,645.6,391.408Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M652.47,395.845c.114.169-.5.781-1.364,1.369s-1.663.927-1.776.759.5-.78,1.364-1.368S652.356,395.677,652.47,395.845Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M657.35,402.464c.08.187-.883.777-2.15,1.317s-2.358.827-2.438.64.883-.776,2.15-1.316S657.271,402.278,657.35,402.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M659.272,409.682c.025.2-.954.488-2.187.641s-2.253.113-2.278-.088.955-.489,2.188-.641S659.247,409.48,659.272,409.682Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M660.272,418.567c-.081.186-1.124-.088-2.33-.612s-2.118-1.1-2.037-1.287,1.124.088,2.33.612S660.353,418.381,660.272,418.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M659.392,426.191c-.065.185-1.384-.129-2.762-1.035s-2.2-1.981-2.056-2.114,1.151.651,2.458,1.5S659.466,425.995,659.392,426.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M655.422,433.132c-.121.157-1.171-.459-2.179-1.548s-1.549-2.178-1.383-2.287.953.749,1.922,1.787S655.551,432.97,655.422,433.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M617.729,433.947c.094.18-1.009.94-2.463,1.7s-2.708,1.225-2.8,1.045,1.008-.94,2.463-1.7S617.635,433.767,617.729,433.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M614.286,427.669c.084.185-.8.766-1.975,1.3s-2.195.814-2.278.629.8-.766,1.975-1.3S614.2,427.484,614.286,427.669Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M611.755,422.109c.028.2-1.06.521-2.431.716s-2.505.189-2.534-.012,1.06-.522,2.431-.716S611.726,421.908,611.755,422.109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M620.056,419.044c.061.189-1,.685-2.417.842s-2.561-.084-2.545-.281,1.122-.294,2.462-.45S620,418.845,620.056,419.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M626.953,412.182c.06.189-.785.617-1.925.727s-2.052-.141-2.03-.338.9-.286,1.958-.394S626.893,411.983,626.953,412.182Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M628.271,406.685c-.067.192-.981.05-2.043-.317s-1.869-.82-1.8-1.012.981-.05,2.043.317S628.337,406.493,628.271,406.685Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M630.8,401.126c-.141.14-.77-.274-1.218-1.053s-.494-1.529-.3-1.581.537.524.939,1.214S630.948,400.983,630.8,401.126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M627.751,423.885c.048.2-.744.56-1.769.811a6.825,6.825,0,0,1-1.486.219l-.145-.429c.265-.048.436-.037.471.041s-.074.212-.289.375l-.145-.429a6.725,6.725,0,0,1,1.42-.491C626.833,423.731,627.7,423.688,627.751,423.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M629.172,433.63c.074.189-.936.763-2.255,1.282s-2.451.786-2.525.6.936-.763,2.256-1.282S629.1,433.441,629.172,433.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M621.381,429.3c.066.193-.608.6-1.5.9s-1.676.4-1.741.205.608-.6,1.5-.9S621.316,429.109,621.381,429.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M621.977,409.464c-.046.194-1.219.078-2.574-.4s-2.34-1.126-2.254-1.307,1.183.15,2.5.614S622.026,409.264,621.977,409.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M640.829,407.307c.112.17-.548.8-1.474,1.413s-1.768.969-1.88.8.549-.8,1.475-1.412S640.718,407.138,640.829,407.307Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M641.854,417.094c.042.2-.652.511-1.549.7s-1.658.176-1.7-.023.653-.511,1.55-.7S641.813,416.895,641.854,417.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M643.045,428.1c-.085.185-1.084-.1-2.231-.628s-2.008-1.111-1.923-1.3,1.085.1,2.232.628S643.131,427.914,643.045,428.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M640.524,438.812c-.157.129-.8-.4-1.449-1.185s-1.038-1.523-.881-1.651.806.4,1.449,1.185S640.681,438.684,640.524,438.812Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M640.009,400.1c.124.157-.3.7-1.039,1.064s-1.423.391-1.475.2.483-.519,1.145-.854S639.883,399.938,640.009,400.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M649.247,409.972c.067.187-.787.658-1.957.818s-2.119-.055-2.1-.253.915-.32,2-.475S649.18,409.776,649.247,409.972Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M647.406,401.111c.09.178-.758.784-1.965,1.168s-2.248.386-2.278.189.908-.52,2.054-.89S647.315,400.926,647.406,401.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M651.264,423.7c0,.2-1.454.326-3.2.006s-3.065-.945-3-1.131,1.44.1,3.13.407S651.27,423.488,651.264,423.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M647.831,436.568c-.122.158-1.191-.472-2.257-1.545s-1.693-2.143-1.535-2.264,1.022.71,2.056,1.745S647.959,436.406,647.831,436.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M632.736,390.637a33.264,33.264,0,0,0-6.444,5.093,31.446,31.446,0,0,0-8.027,17.743,39.835,39.835,0,0,0,.484,10.871,83.341,83.341,0,0,0,2.036,8.725c.705,2.456,1.354,4.423,1.788,5.788a13.407,13.407,0,0,1,.619,2.141,12.4,12.4,0,0,1-.888-2.046c-.519-1.337-1.244-3.284-2.016-5.733a73.457,73.457,0,0,1-2.206-8.758,38.974,38.974,0,0,1-.547-11.074,30.933,30.933,0,0,1,8.383-18.018,23.01,23.01,0,0,1,4.807-3.757,14.414,14.414,0,0,1,1.472-.765A1.717,1.717,0,0,1,632.736,390.637Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M642.76,441.47a80.58,80.58,0,0,0,3.3-7.895,44.691,44.691,0,0,0,1.975-20.3,38.206,38.206,0,0,0-3.13-10.825,25.544,25.544,0,0,0-5.338-7.434,19.416,19.416,0,0,0-5.23-3.305c-1.359-.567-2.174-.7-2.162-.762a1.75,1.75,0,0,1,.6.046,10.942,10.942,0,0,1,1.664.449,18.063,18.063,0,0,1,5.47,3.181,25.147,25.147,0,0,1,5.606,7.533,37.577,37.577,0,0,1,3.247,11.015,43.152,43.152,0,0,1-2.212,20.573c-.415,1.27-.949,2.358-1.348,3.338-.473.948-.864,1.772-1.223,2.424A13.824,13.824,0,0,1,642.76,441.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M614.286,439.732h40.522l.249,8.11h-40.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M617.729,443.787l2.328,24.758H649.68l2.379-24.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M655.056,447.939c0,.2-9.125.368-20.379.368s-20.381-.165-20.381-.368,9.123-.368,20.381-.368S655.056,447.736,655.056,447.939Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M650.939,455.48a6.119,6.119,0,0,1-.868,1.548,22.388,22.388,0,0,1-3.143,3.711l-.187.178-.184-.193a58.35,58.35,0,0,0-7.941-6.952l.448-.019-3.521,3.09-4.162,3.624-.23.2-.231-.194-6.766-5.688.394-.043-3.5,4.271a10.006,10.006,0,0,1-1.374,1.5,9.883,9.883,0,0,1,1.131-1.694c.877-1.174,1.987-2.657,3.308-4.422l.168-.226.226.183,6.867,5.567-.461.006,4.147-3.642,3.531-3.077.218-.189.231.169a51.818,51.818,0,0,1,7.9,7.177l-.37-.015A41.353,41.353,0,0,0,650.939,455.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.455 166.236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.598 203.152)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M184.773,337.692s-20.028,13.6-21.122,45.372c-.366,10.653,4.865,44.586,4.865,44.586l117.149.47-21.919-90.932-36.851-8.42Z",
    transform: "translate(-163.633 -328.767)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.62 18.09)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.313 14.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M250.493,374.916,234.53,441.5l39.889.264Z",
    transform: "translate(-234.53 -374.916)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M256.305,354.452a13.779,13.779,0,0,1,.214,2.178c.092,1.459.2,3.265.33,5.263.118,2.057.2,3.922.223,5.273a12.3,12.3,0,0,1-.045,2.189,13.574,13.574,0,0,1-.214-2.178c-.092-1.459-.2-3.265-.33-5.263-.118-2.057-.2-3.922-.223-5.272A12.134,12.134,0,0,1,256.305,354.452Z",
    transform: "translate(-256.249 -354.452)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.281 7.211)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M265.491,364.818c.009.034-.261.094-.676.337a3.375,3.375,0,0,0-1.327,1.48,2.86,2.86,0,0,0,.139,2.8,2.989,2.989,0,0,0,5.509-.876,2.862,2.862,0,0,0-.737-2.706,3.381,3.381,0,0,0-1.72-.994c-.471-.1-.746-.075-.748-.11,0-.013.066-.027.2-.044a2.156,2.156,0,0,1,.575.013,3.428,3.428,0,0,1,2.683,2.208,3.01,3.01,0,0,1,.076,1.715,3.311,3.311,0,0,1-6.123.974,3.018,3.018,0,0,1-.459-1.654,3.429,3.429,0,0,1,1.866-2.932,2.177,2.177,0,0,1,.543-.191C265.42,364.812,265.488,364.806,265.491,364.818Z",
    transform: "translate(-262.881 -364.691)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.053 43.562)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M283.626,416.43c.009.034-.261.094-.677.337a3.379,3.379,0,0,0-1.326,1.48,2.858,2.858,0,0,0,.139,2.8,2.988,2.988,0,0,0,5.508-.876,2.858,2.858,0,0,0-.737-2.706,3.378,3.378,0,0,0-1.72-.994c-.47-.1-.746-.075-.747-.11,0-.013.065-.027.2-.044a2.163,2.163,0,0,1,.576.013,3.431,3.431,0,0,1,2.683,2.208,3.022,3.022,0,0,1,.076,1.715,3.311,3.311,0,0,1-6.123.974,3.019,3.019,0,0,1-.46-1.654,3.429,3.429,0,0,1,1.866-2.931,2.18,2.18,0,0,1,.544-.191C283.555,416.425,283.623,416.418,283.626,416.43Z",
    transform: "translate(-281.015 -416.303)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.866 17.285)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M211.9,378.995a1.657,1.657,0,0,1-.249.313c-.175.2-.428.49-.773.848a31.113,31.113,0,0,1-3.152,2.807,32.463,32.463,0,0,1-12.535,5.892,24.875,24.875,0,0,1-7.647.626,11.633,11.633,0,0,1-5.872-2.129,8.594,8.594,0,0,1-2.694-3.244,6.588,6.588,0,0,1-.38-1.088,1.671,1.671,0,0,1-.07-.4c.038-.011.143.536.578,1.421a8.793,8.793,0,0,0,2.718,3.1,11.553,11.553,0,0,0,5.752,2,25.167,25.167,0,0,0,7.533-.647,33.519,33.519,0,0,0,12.459-5.742,37.558,37.558,0,0,0,3.208-2.7l.819-.8A1.67,1.67,0,0,1,211.9,378.995Z",
    transform: "translate(-178.521 -378.994)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.866 23.881)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M211.9,388.359a1.659,1.659,0,0,1-.249.313c-.175.2-.428.489-.773.847a31.015,31.015,0,0,1-3.152,2.807,32.463,32.463,0,0,1-12.535,5.893,24.9,24.9,0,0,1-7.647.626,11.632,11.632,0,0,1-5.872-2.13,8.593,8.593,0,0,1-2.694-3.243,6.608,6.608,0,0,1-.38-1.088,1.673,1.673,0,0,1-.07-.4c.038-.011.143.537.578,1.422a8.8,8.8,0,0,0,2.718,3.1,11.553,11.553,0,0,0,5.752,2,25.166,25.166,0,0,0,7.533-.647,33.521,33.521,0,0,0,12.459-5.742,37.412,37.412,0,0,0,3.208-2.7l.819-.8A1.667,1.667,0,0,1,211.9,388.359Z",
    transform: "translate(-178.521 -388.358)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.885)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M210.893,385.525a1.678,1.678,0,0,1,.044.285c.023.207.054.485.092.84.084.758.2,1.842.356,3.229.3,2.805.854,6.856,1.11,11.9a55.86,55.86,0,0,1-.173,8.264,35.706,35.706,0,0,1-2.121,9.246,23.842,23.842,0,0,1-5.7,8.767,21.193,21.193,0,0,1-4.477,3.31,18.011,18.011,0,0,1-5.408,1.907,16.467,16.467,0,0,1-10.951-2.028,21.218,21.218,0,0,1-7.528-7.241,28.53,28.53,0,0,1-3.553-8.791,40.274,40.274,0,0,1-.965-8.211,79.2,79.2,0,0,1,.847-11.925c.2-1.381.356-2.462.465-3.217.056-.353.1-.629.134-.834a1.625,1.625,0,0,1,.058-.282,1.63,1.63,0,0,1-.021.287c-.024.206-.056.485-.1.84-.093.756-.227,1.839-.4,3.224a83.5,83.5,0,0,0-.729,11.9,40.393,40.393,0,0,0,1,8.147,28.317,28.317,0,0,0,3.542,8.679,20.921,20.921,0,0,0,7.418,7.108,16.129,16.129,0,0,0,10.713,1.98,17.671,17.671,0,0,0,5.3-1.866,20.869,20.869,0,0,0,4.4-3.248,23.56,23.56,0,0,0,5.632-8.63,35.581,35.581,0,0,0,2.134-9.156,56.357,56.357,0,0,0,.217-8.221c-.222-5.034-.741-9.09-.993-11.9-.137-1.4-.23-2.5-.287-3.237-.024-.357-.042-.637-.056-.844A1.655,1.655,0,0,1,210.893,385.525Z",
    transform: "translate(-171.612 -385.525)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(2.623 56.774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.337,435.061a23.608,23.608,0,0,0,4.186,8.84,17.781,17.781,0,0,0,9.122,6.918,16.523,16.523,0,0,0,15.829-2.836c4.3-3.6,5.826-9.138,6.575-12.922-1.878,2.521-3.87,6.106-6.228,8.185a18.511,18.511,0,0,1-8.574,4.446,19.37,19.37,0,0,1-12.874-2.863c-3.613-2.3-5.8-6.409-8.037-9.767",
    transform: "translate(-175.337 -435.061)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(5.64 29.452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.621,396.269a12.094,12.094,0,0,0,8.864,6.952c3.814.7,8.75-.5,11.133-4.074-8.384,2.943-16.717,3.01-20-2.878",
    transform: "translate(-179.621 -396.269)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.724 29.253)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M273.038,378.2a1.528,1.528,0,0,1-.538-.031,9.362,9.362,0,0,1-1.433-.311,13.442,13.442,0,0,1-7.573-5.75,9.278,9.278,0,0,1-.685-1.3,1.532,1.532,0,0,1-.175-.51c.058-.027.385.661,1.076,1.665a14.958,14.958,0,0,0,7.435,5.645C272.3,378.008,273.049,378.138,273.038,378.2Z",
    transform: "translate(-262.629 -370.301)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(70.389 29.735)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.573,370.986c.862,2.95,4.129,5.692,7.047,6.657a4.321,4.321,0,0,0,1.783.264,2.086,2.086,0,0,0,1.537-.854,2.3,2.3,0,0,0-.817-2.933,8.273,8.273,0,0,0-3.14-1.116c-2.247-.525-4.279.613-6.14-1.278",
    transform: "translate(-263.573 -370.986)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(8.098 17.38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.13,360.36c5.251,4.591,12.669,4.787,19.363,2.822S207,357.5,212.679,353.443c-6.194,1.227-11.477,4.057-17.724,4.977-5.965.879-12.167.972-18.034-1.022",
    transform: "translate(-175.13 -353.443)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.478 49.168)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M305.014,444.246a.507.507,0,0,1-.134.08,3.627,3.627,0,0,1-.415.192,6.17,6.17,0,0,1-1.706.423,9.469,9.469,0,0,1-6.156-1.652c-2.332-1.484-4.464-3.989-6.735-6.761a73.178,73.178,0,0,1-6.561-9.677,81.9,81.9,0,0,1-7.951-19.651c-.674-2.634-1.109-4.791-1.37-6.288l-.274-1.728a3.852,3.852,0,0,1-.07-.606,3.712,3.712,0,0,1,.144.594q.127.635.341,1.714c.3,1.486.777,3.63,1.48,6.248a85.32,85.32,0,0,0,8.019,19.536,75.235,75.235,0,0,0,6.506,9.648c2.25,2.775,4.349,5.277,6.614,6.755a9.477,9.477,0,0,0,6,1.727A8.406,8.406,0,0,0,305.014,444.246Z",
    transform: "translate(-273.638 -398.577)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(83.532 68.852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.235,426.525s10.391,13.068,17.979,16.276c2.567,1.085,5.4,1.978,7.152,4.146a4.56,4.56,0,0,1,1.1,3.679,2.87,2.87,0,0,1-.142.451c-1.094,2.781-6.327,2.39-8.743.628-1.046-.763-.427-.273-1.271-.909C295.875,448.965,282.867,433.91,282.235,426.525Z",
    transform: "translate(-282.235 -426.525)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 94.253)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M212.355,175.47l6.635-1.32,32.814.388,16.672,3.659,6.358,93.1-73.7,3.446Z",
    transform: "translate(-201.132 -174.15)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.919 1.386)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M284.4,267.557l1.572-42.337-2.617-49.1c10.372,2.671,24.549,5.657,32.385,14.589a47.033,47.033,0,0,1,11.937,25.2c2.173,14.059,5.034,41.024,6.822,56.1",
    transform: "translate(-283.356 -176.118)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.515)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M254.972,260.284l-50.954,8.279-1.8-31.473-2.8-62.21c-14.773.6-31.622,12.826-36.674,22.344-3.509,6.609-6.471,14.288-7.4,21.714-1.763,14.116-4.758,38.228-6.545,53.3a31.057,31.057,0,0,0,8.547,25.279h0c7.4,7.629,18.978,10.265,29.384,8.113l77.584-21.864Z",
    transform: "translate(-148.587 -174.881)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.448 2.913)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.459)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M291.977,260.73a.74.74,0,0,1,.04-.176l.148-.511q.215-.7.6-1.965l2.305-7.309c2-6.239,4.79-14.956,7.994-24.963l.1.219-8.262-3.418-.32-.132.29-.19,1.909-1.249,6.231-4.075-.075.2c-3.165-11.008-5.956-20.712-7.963-27.69-.981-3.467-1.77-6.254-2.32-8.2l-.609-2.213-.149-.575a.925.925,0,0,1-.04-.2.9.9,0,0,1,.073.189l.182.566.669,2.2,2.426,8.169,8.081,27.655.038.129-.113.073-6.229,4.079-1.909,1.249-.03-.323,8.259,3.427.152.063-.051.156-8.116,24.924c-1.019,3.083-1.836,5.554-2.405,7.277-.282.832-.5,1.483-.66,1.947-.074.206-.132.371-.178.5A.781.781,0,0,1,291.977,260.73Z",
    transform: "translate(-291.859 -178.285)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(0 38.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.044,233.565a7.361,7.361,0,0,1-2.568,3.846c-.967.559-.413,1.3.391,2.075.961.926,2.514,1.18,3.222,2.31.659,1.052.314,2.416-.058,3.6a261.345,261.345,0,0,1-12.825,32.84l11.837-36.03-8.261-3.422Z",
    transform: "translate(-291.207 -233.565)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.682 2.015)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M215.176,261.224a.672.672,0,0,1-.078-.145l-.2-.44-.76-1.716c-.66-1.525-1.607-3.71-2.792-6.447l-9.524-22.27-.055-.13.115-.082,6.52-4.659-.006.292-4.322-3.422-1.91-1.512-.945-.749-.235-.187c-.044-.043-.066-.035-.13-.121a.477.477,0,0,1-.1-.2,2.529,2.529,0,0,1-.08-.642,36.433,36.433,0,0,1,.437-4.7c.431-3.054.939-5.982,1.435-8.769,1-5.571,1.99-10.572,2.836-14.767s1.559-7.585,2.064-9.924c.254-1.151.452-2.054.592-2.691l.164-.7a1.318,1.318,0,0,1,.068-.235,1.159,1.159,0,0,1-.032.243l-.128.705-.525,2.705c-.464,2.371-1.129,5.763-1.949,9.946-.812,4.2-1.773,9.205-2.757,14.776-.487,2.786-.988,5.713-1.412,8.759a36.4,36.4,0,0,0-.429,4.643,2.248,2.248,0,0,0,.063.539c-.015.083.209.211.352.337l.944.747,1.907,1.51,4.315,3.419.191.151-.2.14-6.528,4.648.06-.211,9.4,22.321,2.7,6.486.707,1.739.175.452A.651.651,0,0,1,215.176,261.224Z",
    transform: "translate(-200.67 -177.01)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.166 138.293)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.464)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 55.346,
    height: 76.026,
    rx: 2.408,
    transform: "matrix(0.988, 0.153, -0.153, 0.988, 11.597, 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.609 5.536)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 49.165,
    height: 70.768,
    transform: "matrix(0.988, 0.153, -0.153, 0.988, 10.795, 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.744)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.038,248.549a6.024,6.024,0,0,0-4.822-4.11l.406-2.99a4.138,4.138,0,0,0-3.458-4.721h0a4.138,4.138,0,0,0-4.721,3.459l-.479,3.1-1.046-.144a6.027,6.027,0,0,0-5.743,2.493l-.809,1.145,21.154,3.265Zm-8.734-5.465a2.227,2.227,0,1,1,2.541-1.861A2.228,2.228,0,0,1,268.3,243.083Z",
    transform: "translate(-256.367 -236.678)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.709 16.174)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.294,261.693a60.788,60.788,0,0,1-6.615-.835,60.525,60.525,0,0,1-6.56-1.2,60.715,60.715,0,0,1,6.616.836A60.693,60.693,0,0,1,255.294,261.693Z",
    transform: "translate(-242.119 -259.643)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.366 18.381)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M247.981,263.788a28.207,28.207,0,0,1-6.349-.98,28.2,28.2,0,0,1,6.349.98Z",
    transform: "translate(-241.632 -262.776)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.046 24.696)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.845,277.408c-.016.1-8.237-1.086-18.361-2.649s-18.323-2.911-18.307-3.011,8.235,1.085,18.363,2.649S277.86,277.308,277.845,277.408Z",
    transform: "translate(-241.177 -271.743)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.506 28.192)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M277.079,282.372c-.015.1-8.237-1.086-18.361-2.648s-18.322-2.912-18.306-3.012,8.235,1.085,18.363,2.649S277.094,282.272,277.079,282.372Z",
    transform: "translate(-240.411 -276.707)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.966 31.689)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M276.312,287.337c-.015.1-8.238-1.086-18.361-2.649s-18.323-2.911-18.307-3.011,8.236,1.085,18.363,2.649S276.328,287.237,276.312,287.337Z",
    transform: "translate(-239.644 -281.672)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.426 35.185)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M275.546,292.3c-.015.1-8.237-1.085-18.361-2.648s-18.323-2.912-18.307-3.012,8.235,1.086,18.363,2.649S275.561,292.2,275.546,292.3Z",
    transform: "translate(-238.878 -286.636)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.887 38.682)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M274.78,297.266c-.016.1-8.237-1.086-18.361-2.649s-18.322-2.911-18.306-3.011,8.235,1.085,18.363,2.649S274.8,297.166,274.78,297.266Z",
    transform: "translate(-238.112 -291.601)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.347 42.178)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M274.013,302.23c-.016.1-8.237-1.085-18.361-2.648s-18.323-2.911-18.307-3.012,8.235,1.086,18.363,2.649S274.029,302.13,274.013,302.23Z",
    transform: "translate(-237.345 -296.565)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.86 45.326)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.989,303.875a2.851,2.851,0,0,1-.732-.041c-.467-.05-1.141-.134-1.973-.246-1.664-.223-3.958-.556-6.489-.947s-4.821-.765-6.475-1.054c-.827-.144-1.5-.268-1.955-.361a2.878,2.878,0,0,1-.71-.182,2.812,2.812,0,0,1,.732.041c.467.049,1.141.134,1.973.245,1.664.223,3.96.557,6.491.948s4.82.764,6.473,1.053c.828.145,1.5.268,1.956.361A2.8,2.8,0,0,1,254.989,303.875Z",
    transform: "translate(-236.654 -301.033)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.775 20.934)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M294.94,267.344a24.153,24.153,0,0,1-5.873-.906,24.135,24.135,0,0,1,5.873.906Z",
    transform: "translate(-289.067 -266.402)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.161 53.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M245.185,313.433a63.5,63.5,0,0,1-9.524-1.471,31.8,31.8,0,0,1,4.79.554A31.663,31.663,0,0,1,245.185,313.433Z",
    transform: "translate(-235.661 -311.941)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.829 56.208)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M244.873,318a65.627,65.627,0,0,1-9.683-1.495,32.8,32.8,0,0,1,4.87.566A32.8,32.8,0,0,1,244.873,318Z",
    transform: "translate(-235.19 -316.484)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.775 57.533)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M286.571,319.12a14.869,14.869,0,0,1-4.6-.711,14.867,14.867,0,0,1,4.6.711Z",
    transform: "translate(-281.968 -318.366)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.492 60.415)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M286.17,323.211a14.868,14.868,0,0,1-4.6-.711,14.87,14.87,0,0,1,4.6.711Z",
    transform: "translate(-281.567 -322.457)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.108 59.641)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M240.031,322.089a13.89,13.89,0,0,1-4.444-.686,13.839,13.839,0,0,1,4.444.686Z",
    transform: "translate(-235.587 -321.358)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.407 63.955)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M286.2,328.056a7.844,7.844,0,0,1-3.333-.515,7.844,7.844,0,0,1,3.333.515Z",
    transform: "translate(-282.865 -327.484)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.653 63.978)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M233.52,330.707a5.263,5.263,0,0,1,.83-.009l2.341.068,8.352.334.19.008-.043.186a4.014,4.014,0,0,1-1.464,2.272,3.309,3.309,0,0,1-2.821.643,3.275,3.275,0,0,1-2.312-2,2.861,2.861,0,0,1,.855-3.047,2.594,2.594,0,0,1,1.118-.587,1.54,1.54,0,0,1,.315-.051,1.113,1.113,0,0,1,.342,0,.479.479,0,0,1,.361.267.743.743,0,0,1,.042.38,5.493,5.493,0,0,1-2.326,3.869,3.421,3.421,0,0,1-2.08.694,1.973,1.973,0,0,1-1.69-1.217,2.964,2.964,0,0,1-.141-1.969,7.073,7.073,0,0,1,1.971-2.833l.189-.2.034.268a4.792,4.792,0,0,1-.535,2.833,5.078,5.078,0,0,1-1.4,1.668,4.491,4.491,0,0,1-1.2.662,1.94,1.94,0,0,1-.465.116,5.937,5.937,0,0,0,1.58-.89,5.072,5.072,0,0,0,1.3-1.65,4.608,4.608,0,0,0,.461-2.7l.223.072a6.9,6.9,0,0,0-1.865,2.733,2.658,2.658,0,0,0,.141,1.752,1.641,1.641,0,0,0,1.416,1.014,3.1,3.1,0,0,0,1.861-.644,5.155,5.155,0,0,0,2.163-3.617.415.415,0,0,0-.013-.193c-.015-.03-.03-.043-.1-.058a1.571,1.571,0,0,0-.506.046,2.24,2.24,0,0,0-.959.506,2.5,2.5,0,0,0-.756,2.651,2.926,2.926,0,0,0,2.054,1.781,2.97,2.97,0,0,0,2.532-.568,3.7,3.7,0,0,0,1.36-2.074l.147.194-8.347-.466-2.337-.156A5.363,5.363,0,0,1,233.52,330.707Z",
    transform: "translate(-233.52 -327.516)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.065 66.786)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.415,337.137a1.8,1.8,0,0,1-.4.42,2.363,2.363,0,0,1-.594.381,1.377,1.377,0,0,1-.97.05.962.962,0,0,1-.486-.357,1.208,1.208,0,0,1-.2-.621,11.409,11.409,0,0,1,.092-1.349l.313-3.138.306.12-2.69,3.64-.674.905-.436.586.109-.721c.283-1.882.548-3.638.78-5.177l.257.142a16.325,16.325,0,0,0-2.89,3.169c-.593.854-.873,1.383-.909,1.364a1.433,1.433,0,0,1,.161-.4,11.6,11.6,0,0,1,.594-1.064,14.825,14.825,0,0,1,2.839-3.307l.316-.275-.058.417c-.217,1.541-.465,3.3-.73,5.185l-.328-.135q.331-.447.673-.906l2.71-3.625.38-.508-.074.628c-.132,1.129-.255,2.18-.366,3.133a12.491,12.491,0,0,0-.127,1.3.8.8,0,0,0,.5.8,1.547,1.547,0,0,0,1.425-.323A3.2,3.2,0,0,1,279.415,337.137Z",
    transform: "translate(-271.021 -331.503)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.886 70.282)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M278.9,336.684a65.009,65.009,0,0,1-6.906.152,65.108,65.108,0,0,1-6.905-.214,65,65,0,0,1,6.906-.152A65.083,65.083,0,0,1,278.9,336.684Z",
    transform: "translate(-265.088 -336.467)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.866 72.663)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M283.237,339.875a42.443,42.443,0,0,1-5.519.785,42.492,42.492,0,0,1-5.559.42,84.706,84.706,0,0,1,11.078-1.2Z",
    transform: "translate(-272.159 -339.847)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.034 212.37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M343.152,341.855",
    transform: "translate(-343.152 -341.855)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(35.659 138.472)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.421,236.932c-.084,2.128.486,4.266,2.252,5.456a6.908,6.908,0,0,0-3.453,6.087,17.81,17.81,0,0,0,1.7,7.1c2.848,7,8.936,16.842,13.581,22.8,0,0-2.357-6.35-3.029-7.819-3.062-6.686-5.756-13.407-8.818-20.092-.339-.742-.946-2.757-.946-2.757a6.019,6.019,0,0,0,.915-.631c1.716-1.368,5.447-3.876,5.447-3.876s-7.653-6.058-7.653-6.27",
    transform: "translate(-199.216 -236.932)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.566 152.837)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M200.277,257.328c.1,0-.077,8.133-.4,18.156s-.664,18.149-.766,18.147.077-8.131.4-18.158S200.176,257.325,200.277,257.328Z",
    transform: "translate(-199.085 -257.328)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.411 166.381)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.292 14.101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M217.283,296.58,207.8,319.912l75.68,20.984a24.268,24.268,0,0,0,20.469-3.551h0c7.916-5.582,9.851-15.354,8.891-25.023l-1.342-10.258Z",
    transform: "translate(-207.797 -296.58)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.717 18.344)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M327.875,323.691c-.084.013-.245-1.594-1.024-4.055a20.145,20.145,0,0,0-.728-1.977c-.266-.711-.642-1.428-1.015-2.194a27.062,27.062,0,0,0-6.965-8.515c-.676-.518-1.306-1.028-1.949-1.43a20.147,20.147,0,0,0-1.795-1.105c-2.257-1.252-3.8-1.728-3.77-1.807a6.594,6.594,0,0,1,1.078.333,10.187,10.187,0,0,1,1.232.487,16.953,16.953,0,0,1,1.584.759,18.963,18.963,0,0,1,1.838,1.079c.659.4,1.3.9,1.993,1.42a26.125,26.125,0,0,1,7.054,8.624c.37.779.739,1.511,1,2.235a19.008,19.008,0,0,1,.693,2.015,17.1,17.1,0,0,1,.43,1.7,10.3,10.3,0,0,1,.233,1.3A6.675,6.675,0,0,1,327.875,323.691Z",
    transform: "translate(-310.629 -302.605)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(0 4.648)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.652,302.54c-5.78.478-10.231,1.011-16.215,1.743-3.722.456-7.593.2-8.807-3.35a12.825,12.825,0,0,1,1.551-10.77c2-3.176,5.143-10.595,21.961-4.941Z",
    transform: "translate(-169.048 -283.159)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.394 13.968)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M216.463,305.436a.62.62,0,0,1,.042-.161c.042-.123.094-.275.157-.462l.637-1.773,2.429-6.561.033-.089.1.009,25.738,2.328,24.906,2.364,7.543.759,2.049.225.532.068a.715.715,0,0,1,.18.035.68.68,0,0,1-.184,0l-.535-.032-2.056-.156-7.554-.642-24.916-2.257-25.726-2.445.128-.08-2.536,6.52q-.444,1.111-.7,1.75c-.076.182-.138.33-.189.45A.576.576,0,0,1,216.463,305.436Z",
    transform: "translate(-216.461 -296.391)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(64.528 35.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.667,338.39c10.749,2.881,17.283,1.209,27.047-4.131a52.115,52.115,0,0,0,5.749-3.9,20.8,20.8,0,0,0,3.681-3.905c-12.574,4.81-23.013,8.426-35.973,12.071",
    transform: "translate(-260.667 -326.451)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.497)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M203.524,299.317l2.457-6.866-5.713-8.935a6.728,6.728,0,0,0-4.422-2.988l-21.014-3.97a3.389,3.389,0,0,0,1.771,4.132c2.755,1.574,15.143,4.458,15.143,4.458l-19.078-.325s-.59,2.755,1.575,3.739S190,290.046,190,290.046l-17.4,2.452s-.1,2.763,3.878,2.795a115.077,115.077,0,0,0,11.727-.736.621.621,0,0,1,.7.515h0a.623.623,0,0,1-.472.709l-11.57,2.732a1.551,1.551,0,0,0-.118,2.992,1.845,1.845,0,0,0,.647.046c1.967-.2,13.748-1.69,13.748-1.69l.61,1.373,11.777-1.915",
    transform: "translate(-172.593 -276.559)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.613 18.353)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M201.017,304.9a3.72,3.72,0,0,0-.647-1.045,2.928,2.928,0,0,0-1.11-.685,4.22,4.22,0,0,0-1.607-.178c-1.17.085-2.224.42-3.017.523a2.83,2.83,0,0,1-1.294.02,11.779,11.779,0,0,1,1.245-.275,19.065,19.065,0,0,1,3.044-.635,4.208,4.208,0,0,1,1.745.227,2.938,2.938,0,0,1,1.186.828A1.492,1.492,0,0,1,201.017,304.9Z",
    transform: "translate(-193.341 -302.617)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.337 13.158)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M201.54,297.489c-.032,0-.051-.194-.209-.5a2.427,2.427,0,0,0-1-.987c-1.066-.621-2.86-.416-4.748-.289-1.9.159-3.619.408-4.865.571a11.73,11.73,0,0,1-2.028.2,10.793,10.793,0,0,1,1.987-.459c1.237-.228,2.955-.518,4.875-.68.961-.077,1.874-.125,2.718-.109a4.347,4.347,0,0,1,2.192.539,2.373,2.373,0,0,1,1,1.152A.861.861,0,0,1,201.54,297.489Z",
    transform: "translate(-188.69 -295.241)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.002 8.415)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M204.946,292.451a3.5,3.5,0,0,0-.442-1.59,3.613,3.613,0,0,0-1.272-1.228,5.38,5.38,0,0,0-2.1-.62c-1.58-.149-3.062.033-4.134-.086a3.754,3.754,0,0,1-1.684-.409c.017-.056.648.131,1.7.151,1.048.053,2.505-.174,4.159-.02a5.411,5.411,0,0,1,2.235.694,3.662,3.662,0,0,1,1.325,1.391,2.568,2.568,0,0,1,.313,1.255A.848.848,0,0,1,204.946,292.451Z",
    transform: "translate(-195.313 -288.507)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.765 150.107)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M305.862,282.067a6.762,6.762,0,0,1,.111-1.141c.089-.732.266-1.786.513-3.081.485-2.594,1.343-6.135,2.252-10.046a89.8,89.8,0,0,0,1.838-10.1c.087-.651.123-1.245.17-1.765s.077-.968.092-1.336a6.865,6.865,0,0,1,.1-1.142,6.885,6.885,0,0,1,.044,1.146c.007.369,0,.821-.03,1.345s-.046,1.121-.116,1.778A74.6,74.6,0,0,1,309.1,267.88c-.911,3.919-1.807,7.443-2.355,10.017-.278,1.285-.494,2.328-.626,3.052A6.862,6.862,0,0,1,305.862,282.067Z",
    transform: "translate(-305.855 -253.453)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.432 213.871)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M299.593,355.041a1.859,1.859,0,0,1-.414-.068l-1.17-.266-4.284-1.054c-3.612-.913-8.588-2.223-14.063-3.749s-10.413-2.98-13.976-4.067l-4.21-1.314-1.139-.378a1.823,1.823,0,0,1-.389-.156,1.8,1.8,0,0,1,.411.085l1.158.313,4.243,1.2,14,3.962,14.03,3.851,4.253,1.167,1.153.332A1.76,1.76,0,0,1,299.593,355.041Z",
    transform: "translate(-259.948 -343.986)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.737 226.924)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M176.61,362.519",
    transform: "translate(-176.61 -362.519)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.951 0.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M213.3,60.972c1.546-4.778,9.486-9.1,13.84-11.6,6.511-3.743,12.549-2.991,16.266.337,6.723-5.642,15.572-11.057,24.063-8.838S282.847,51.778,281.3,60.417c-.911,5.09-4.437,9.655-4.231,14.822.141,3.522,2.005,6.7,3.491,9.9s2.63,6.921,1.305,10.186c-1.233,3.04-4.31,4.936-5.967,7.766-1.349,2.305-1.662,5.054-2.525,7.583-3.2,9.369-14.259,14.62-24.023,12.975s-17.891-8.994-22.5-17.756-6.135-18.818-6.672-28.7",
    transform: "translate(-213.3 -40.357)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.145 17.066)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M223.514,74.7l1.947,78.11c.7,8.953,8.953,15.484,18.535,14.662h0c9.676-.83,17.063-8.838,16.506-17.894-.585-9.505-1.025-19.523-1.025-19.523s12.112-2.823,13.617-18.96c.772-8.269-.568-21.817-1.973-32.586a16.022,16.022,0,0,0-18.6-13.719",
    transform: "translate(-223.514 -64.556)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.938 21.533)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.02 2.266)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M284.33,100.074a2.053,2.053,0,0,1-1.842,2.194,1.963,1.963,0,0,1-2.231-1.71,2.054,2.054,0,0,1,1.84-2.2A1.966,1.966,0,0,1,284.33,100.074Z",
    transform: "translate(-280.247 -98.347)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M285.484,97.036c-.237.284-1.863-.765-4.067-.616-2.2.116-3.748,1.354-4,1.1-.125-.112.1-.611.774-1.169a5.632,5.632,0,0,1,3.185-1.211,5.407,5.407,0,0,1,3.258.825C285.341,96.44,285.6,96.908,285.484,97.036Z",
    transform: "translate(-277.379 -95.129)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.295 23.343)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.471 2.671)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.241,103.218a2.053,2.053,0,0,1-1.842,2.195,1.964,1.964,0,0,1-2.231-1.711,2.054,2.054,0,0,1,1.84-2.2A1.965,1.965,0,0,1,254.241,103.218Z",
    transform: "translate(-250.159 -101.491)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M254.756,99.606c-.237.283-1.865-.764-4.067-.616-2.2.116-3.748,1.354-4.005,1.1-.125-.112.1-.611.775-1.169a5.63,5.63,0,0,1,3.184-1.211,5.416,5.416,0,0,1,3.259.824C254.61,99.01,254.872,99.478,254.756,99.606Z",
    transform: "translate(-246.65 -97.699)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.243 22.777)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.087,115.2a14.648,14.648,0,0,1,3.539-.877c.559-.094,1.084-.241,1.154-.631a2.868,2.868,0,0,0-.484-1.644q-.925-1.992-1.941-4.179c-2.706-5.954-4.7-10.864-4.462-10.971s2.629,4.632,5.335,10.586q.98,2.2,1.873,4.209a3.264,3.264,0,0,1,.435,2.19,1.417,1.417,0,0,1-.873.883,3.829,3.829,0,0,1-.947.194A14.339,14.339,0,0,1,270.087,115.2Z",
    transform: "translate(-267.873 -96.897)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.202 61.173)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M265.439,155.738a40.715,40.715,0,0,1-21.76-4.326s6.051,10.753,21.942,8.226Z",
    transform: "translate(-243.679 -151.412)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.414 15.176)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M253.978,87.5c-.179.613-2.4.471-4.965.95-2.576.427-4.613,1.318-4.99.8-.17-.247.157-.834.963-1.469a8.784,8.784,0,0,1,7.584-1.335C253.545,86.771,254.053,87.211,253.978,87.5Z",
    transform: "translate(-243.98 -86.104)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.287 15.064)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M283.989,87.992c-.356.526-1.908.1-3.736.2-1.83.029-3.35.554-3.741.053-.172-.244.039-.761.684-1.279a5.414,5.414,0,0,1,6.023-.2C283.9,87.235,284.144,87.737,283.989,87.992Z",
    transform: "translate(-276.456 -85.945)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.272 62.295)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M265.358,128.774a6.751,6.751,0,0,1,4.049,1.417,2.558,2.558,0,0,1,1.043,1.031,2.179,2.179,0,0,1-.218,1.919,3.864,3.864,0,0,1-3.654,1.951,3.556,3.556,0,0,1-3.068-2.715,3.3,3.3,0,0,1,1.847-3.6",
    transform: "translate(-263.449 -128.774)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.649 61.472)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M270.949,132.118c.026.167-.551.424-1.512.366a8.231,8.231,0,0,1-3.455-1.129,9.493,9.493,0,0,1-2.762-2.317c-.576-.742-.751-1.322-.605-1.416.3-.188,1.745,1.33,4.022,2.583a17.164,17.164,0,0,0,2.971,1.359C270.394,131.835,270.927,131.924,270.949,132.118Z",
    transform: "translate(-262.566 -127.605)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.565 51.057)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "z",
    cx: 0.585,
    cy: 0.585,
    rx: 0.585,
    ry: 0.585
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.115 48.192)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M282.856,109.335a.585.585,0,1,1-.585-.585A.585.585,0,0,1,282.856,109.335Z",
    transform: "translate(-281.685 -108.75)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.347 49.715)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M287.445,111.5a.585.585,0,1,1-.585-.585A.585.585,0,0,1,287.445,111.5Z",
    transform: "translate(-286.274 -110.913)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.331 47.268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M288.842,108.024a.586.586,0,1,1-.585-.585A.585.585,0,0,1,288.842,108.024Z",
    transform: "translate(-287.671 -107.439)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.887 53.642)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M255.555,117.074a.585.585,0,1,1-.585-.585A.585.585,0,0,1,255.555,117.074Z",
    transform: "translate(-254.384 -116.489)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.493 10.419)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M245.221,59.718a34.154,34.154,0,0,1-23.09,28.046c3.94,5.677,1.459,16.477,1.56,25.495.094,8.383.089,10.779-5.342,15.051-4.487,1.082-7.075-11.214-10.41-14.648s-6.527-7.669-6.279-12.449c.116-2.235.989-4.377,1.111-6.611.136-2.479-.656-4.9-1.1-7.345-1.945-10.814,3.662-22.441,13.081-28.1s21.992-5.27,31.335.513",
    transform: "translate(-201.291 -55.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.337 48.278)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M211.9,127.936a30.946,30.946,0,0,0-5.894-11.232l.2.437a13.824,13.824,0,1,0-21.291,16.351,3.241,3.241,0,0,0-3.546,2.6,6.039,6.039,0,0,0,1.188,4.594,11.379,11.379,0,0,0,15.5,2.638c3.73,2.527,9.25,1.054,12.018-2.5S213.178,132.258,211.9,127.936Z",
    transform: "translate(-179.772 -108.873)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.998 13.944)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M203.357,94.881a3.614,3.614,0,0,1-.4-.45,4.6,4.6,0,0,1-.74-1.561,9.249,9.249,0,0,1,.928-6.2,12.224,12.224,0,0,1,2.546-3.572,24.344,24.344,0,0,1,3.834-3.262,20.372,20.372,0,0,1,4.977-2.493c1.828-.621,3.762-1.109,5.737-1.6s3.9-.983,5.7-1.615a35.519,35.519,0,0,0,5.05-2.193,37.509,37.509,0,0,0,7.617-5.358,38.146,38.146,0,0,0,4.284-4.613c.467-.58.8-1.052,1.035-1.368a3.679,3.679,0,0,1,.373-.471,3.7,3.7,0,0,1-.312.513c-.213.33-.531.817-.983,1.413a34.98,34.98,0,0,1-4.222,4.717,36.75,36.75,0,0,1-7.634,5.465,35.158,35.158,0,0,1-5.091,2.233c-1.821.644-3.757,1.136-5.732,1.632s-3.9.976-5.711,1.588a20.186,20.186,0,0,0-4.9,2.433,24.358,24.358,0,0,0-3.805,3.194,12.06,12.06,0,0,0-2.531,3.473,9.264,9.264,0,0,0-1.023,6.049A5.555,5.555,0,0,0,203.357,94.881Z",
    transform: "translate(-202.007 -60.125)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.212 13.944)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M243.972,60.125a2.825,2.825,0,0,1-.33.4c-.223.259-.568.627-1.016,1.1a44.038,44.038,0,0,1-4.064,3.7,28.317,28.317,0,0,1-6.984,4.215,26.972,26.972,0,0,1-4.663,1.263c-1.64.327-3.35.585-5.1.849A57.1,57.1,0,0,0,212.1,73.7a21.358,21.358,0,0,0-7.03,3.89,13.869,13.869,0,0,0-3.393,4.217,12.733,12.733,0,0,0-.586,1.364,2.828,2.828,0,0,1-.2.481,2.656,2.656,0,0,1,.13-.5,10.059,10.059,0,0,1,.528-1.4,13.461,13.461,0,0,1,3.35-4.35,21.2,21.2,0,0,1,7.091-4.014,55.487,55.487,0,0,1,9.769-2.085c1.747-.263,3.453-.518,5.084-.838a27.159,27.159,0,0,0,4.609-1.226,28.836,28.836,0,0,0,6.947-4.1,51.39,51.39,0,0,0,4.124-3.6l1.062-1.047A2.821,2.821,0,0,1,243.972,60.125Z",
    transform: "translate(-200.892 -60.124)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M279.866,40.339c.008.082-1.374.129-3.5.7a15.873,15.873,0,0,0-1.713.549,20.544,20.544,0,0,0-1.9.8A21.38,21.38,0,0,0,265.4,48.22c-.439.579-.873,1.118-1.209,1.671a16,16,0,0,0-.922,1.545c-1.033,1.947-1.391,3.283-1.469,3.256a4.889,4.889,0,0,1,.244-.935,7.881,7.881,0,0,1,.381-1.068,13.074,13.074,0,0,1,.615-1.372,14.614,14.614,0,0,1,.9-1.59,19.431,19.431,0,0,1,1.2-1.718,20.631,20.631,0,0,1,7.462-5.93,19.543,19.543,0,0,1,1.945-.782,14.842,14.842,0,0,1,1.75-.513,13.125,13.125,0,0,1,1.476-.289,7.912,7.912,0,0,1,1.127-.129A4.884,4.884,0,0,1,279.866,40.339Z",
    transform: "translate(-261.8 -40.326)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.638 13.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M291.85,106.75s.031-.053.106-.142l.335-.392c.294-.344.735-.846,1.24-1.538a8.671,8.671,0,0,0,1.415-2.741,4.848,4.848,0,0,0,.147-1.9,5.328,5.328,0,0,0-.723-2,35.72,35.72,0,0,0-3.153-3.889,22.724,22.724,0,0,1-4.751-11.129,46.889,46.889,0,0,1-.171-6.869,23.945,23.945,0,0,0-.622-6.751,13.526,13.526,0,0,0-3.05-5.449,13.67,13.67,0,0,0-4.585-3.331,12.98,12.98,0,0,0-4.821-1.111,14.2,14.2,0,0,0-6.988,1.537,15.185,15.185,0,0,0-1.689,1.016l-.419.3a.669.669,0,0,1-.151.092,10.079,10.079,0,0,1,2.193-1.533,14.021,14.021,0,0,1,7.063-1.67,13.156,13.156,0,0,1,4.935,1.092,14.142,14.142,0,0,1,7.858,8.962,24.076,24.076,0,0,1,.642,6.852,47.423,47.423,0,0,0,.161,6.818,22.59,22.59,0,0,0,4.633,10.987,34.859,34.859,0,0,1,3.14,3.948,5.56,5.56,0,0,1,.73,2.105,5.047,5.047,0,0,1-.181,1.98,8.626,8.626,0,0,1-1.5,2.771,18.093,18.093,0,0,1-1.3,1.5l-.363.367C291.9,106.715,291.855,106.754,291.85,106.75Z",
    transform: "translate(-263.97 -59.244)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.271 48.278)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M219,144.468a1.747,1.747,0,0,1-.344-.232c-.218-.161-.533-.408-.936-.73a28.168,28.168,0,0,1-3.2-2.976,11.555,11.555,0,0,1-3.01-5.718,28,28,0,0,1-.174-3.831,6.6,6.6,0,0,0-1.1-3.779,23.336,23.336,0,0,0-2.754-2.984,11.22,11.22,0,0,1-2.269-3.117,13.742,13.742,0,0,1-1.1-3.311,13.45,13.45,0,0,1-.292-3.023c.04-.935.224-1.754.306-2.474a8.065,8.065,0,0,0,.04-1.852c-.118-1.014-.315-1.557-.276-1.566a1.735,1.735,0,0,1,.15.387,7.474,7.474,0,0,1,.268,1.162,7.746,7.746,0,0,1,.023,1.891c-.064.735-.229,1.553-.251,2.461a14.512,14.512,0,0,0,1.433,6.175,11,11,0,0,0,2.222,3.015,23,23,0,0,1,2.8,3.03,5.99,5.99,0,0,1,.894,1.935,9.166,9.166,0,0,1,.259,2.038,28.666,28.666,0,0,0,.149,3.79,11.463,11.463,0,0,0,2.871,5.6,32.955,32.955,0,0,0,3.1,3.039l.891.781A1.822,1.822,0,0,1,219,144.468Z",
    transform: "translate(-203.815 -108.873)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.767 82.346)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M186.061,157.244",
    transform: "translate(-186.061 -157.244)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.825 67.467)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M205.354,136.118a.861.861,0,0,1,.011.289c-.012.188,0,.47-.055.825a13.3,13.3,0,0,1-.683,2.967,14.485,14.485,0,0,1-15.962,9.555,13.271,13.271,0,0,1-2.938-.8,8.053,8.053,0,0,1-.753-.342c-.169-.085-.255-.135-.25-.146a20.835,20.835,0,0,0,3.977,1.03,15.077,15.077,0,0,0,4.431-.071,14.079,14.079,0,0,0,9.1-5.445,15.106,15.106,0,0,0,2.155-3.872A20.78,20.78,0,0,0,205.354,136.118Z",
    transform: "translate(-184.725 -136.118)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.431 64.158)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M202.048,131.42a4.186,4.186,0,0,1-.206.963,13.727,13.727,0,0,1-.993,2.5,16.186,16.186,0,0,1-6,6.434,17.454,17.454,0,0,1-8.454,2.477,15.723,15.723,0,0,1-2.683-.139,4.358,4.358,0,0,1-.964-.2,34.973,34.973,0,0,0,3.636.08A18.111,18.111,0,0,0,194.656,141a16.709,16.709,0,0,0,5.964-6.242A27.068,27.068,0,0,0,202.048,131.42Z",
    transform: "translate(-182.745 -131.42)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.134 55.416)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M180.9,120.732a2.79,2.79,0,0,1,.633-.366,5.63,5.63,0,0,1,.783-.35,9.5,9.5,0,0,1,1.073-.378,14.717,14.717,0,0,1,2.909-.568,17.12,17.12,0,0,1,3.631.073,17.424,17.424,0,0,1,3.524.883,14.242,14.242,0,0,1,2.646,1.337,8.7,8.7,0,0,1,.928.661,5.285,5.285,0,0,1,.652.558,2.813,2.813,0,0,1,.5.532c-.051.057-.792-.68-2.217-1.53a15.681,15.681,0,0,0-2.627-1.241,18.535,18.535,0,0,0-3.456-.835,18.178,18.178,0,0,0-3.553-.1,16.226,16.226,0,0,0-2.867.481C181.859,120.313,180.936,120.8,180.9,120.732Z",
    transform: "translate(-180.903 -119.007)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.745 38.692)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M195.694,112.413c-.067.076-4.509-3.7-9.922-8.437s-9.748-8.638-9.681-8.714,4.508,3.7,9.922,8.438S195.761,112.337,195.694,112.413Z",
    transform: "translate(-176.091 -95.261)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.898 14.109)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M204.244,98.341a.594.594,0,0,1-.092-.139l-.237-.43a6.236,6.236,0,0,1-.547-1.8,8.979,8.979,0,0,1,1.855-6.548,10.751,10.751,0,0,1,1.57-1.7,12.576,12.576,0,0,1,2.074-1.4,18.172,18.172,0,0,1,5.2-1.788c3.81-.8,8.1-.6,12.468-1.255a19.118,19.118,0,0,0,6.111-1.9,18.38,18.38,0,0,0,4.728-3.632A28.965,28.965,0,0,0,242.82,69.2c1.157-2.666,1.885-4.912,2.411-6.452l.6-1.779.163-.46a.6.6,0,0,1,.067-.154.541.541,0,0,1-.031.164l-.128.472q-.2.661-.531,1.8a67.634,67.634,0,0,1-2.309,6.512,28.747,28.747,0,0,1-5.441,8.669,18.588,18.588,0,0,1-4.8,3.717,19.338,19.338,0,0,1-6.223,1.945c-4.427.659-8.7.454-12.459,1.225-3.747.69-7.006,2.344-8.7,4.714a8.937,8.937,0,0,0-1.921,6.373A7.932,7.932,0,0,0,204.244,98.341Z",
    transform: "translate(-203.285 -60.359)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 51.334)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M199.97,141.9a10.41,10.41,0,0,1-.871,2.857,13.185,13.185,0,0,1-1.84,2.993,12.327,12.327,0,0,1-3.56,3,11.684,11.684,0,0,1-5.451,1.421,10.685,10.685,0,0,1-6.185-1.811,10.361,10.361,0,0,1-4.1-5.8,9.07,9.07,0,0,1-.213-3.811,9.227,9.227,0,0,1,1.471-3.644,8.845,8.845,0,0,1,5.236-3.709l.013.354a14.219,14.219,0,0,1-6.045-2.459,11.653,11.653,0,0,1-3.844-4.615,10.885,10.885,0,0,1-.933-5.3,8.971,8.971,0,0,1,1.53-4.39,9.118,9.118,0,0,1,2.786-2.6,8.512,8.512,0,0,1,2.667-1.028,7.264,7.264,0,0,1,1.79-.135l.462.049a.536.536,0,0,1,.155.028,9.231,9.231,0,0,0-2.381.183,8.625,8.625,0,0,0-2.6,1.062,9.014,9.014,0,0,0-2.687,2.576,8.767,8.767,0,0,0-1.445,4.278,10.629,10.629,0,0,0,.942,5.151,11.358,11.358,0,0,0,3.756,4.466,13.913,13.913,0,0,0,5.9,2.382l.91.144-.9.211a8.5,8.5,0,0,0-5.013,3.562,8.888,8.888,0,0,0-1.415,3.5,8.722,8.722,0,0,0,.2,3.659,10.04,10.04,0,0,0,3.946,5.613,10.41,10.41,0,0,0,5.99,1.786,11.478,11.478,0,0,0,5.329-1.345,12.254,12.254,0,0,0,3.526-2.9,13.446,13.446,0,0,0,1.868-2.922,14.913,14.913,0,0,0,.783-2.057l.154-.554A.788.788,0,0,1,199.97,141.9Z",
    transform: "translate(-173.614 -113.211)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.369 11.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M201.83,94.824a.707.707,0,0,1-.173-.077l-.489-.258a12.921,12.921,0,0,1-1.752-1.207,14.764,14.764,0,0,1-4.525-6.308,14.67,14.67,0,0,1,4.953-16.654,20.58,20.58,0,0,1,6.611-3.235,37.21,37.21,0,0,1,7.241-1.32c2.366-.225,4.651-.329,6.821-.48a58.956,58.956,0,0,0,6.125-.687,27.627,27.627,0,0,0,5.165-1.4,18.392,18.392,0,0,0,6.516-4.1,15.84,15.84,0,0,0,1.363-1.611l.321-.447a.767.767,0,0,1,.12-.146,10.947,10.947,0,0,1-1.7,2.3,18.062,18.062,0,0,1-6.524,4.244A27.418,27.418,0,0,1,226.7,64.9a57.976,57.976,0,0,1-6.155.724c-4.333.345-9.174.38-13.981,1.815a20.328,20.328,0,0,0-6.5,3.169,14.154,14.154,0,0,0-4.258,5.154,14.327,14.327,0,0,0-.669,11.125,15.052,15.052,0,0,0,6.071,7.541l.469.289A.725.725,0,0,1,201.83,94.824Z",
    transform: "translate(-194.015 -56.891)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.907 5.301)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M310.355,81.768a.935.935,0,0,1-.659.325,1.835,1.835,0,0,1-1.721-1.12,1.665,1.665,0,0,1,.1-1.535,2.836,2.836,0,0,1,1.41-1.19,4.464,4.464,0,0,1,4.3.673,4.687,4.687,0,0,1,1.6,2.069,4.925,4.925,0,0,1,.2,2.83,4.678,4.678,0,0,1-1.565,2.6,5.643,5.643,0,0,1-2.966,1.253,7.775,7.775,0,0,1-6.263-2.47,8.771,8.771,0,0,1-2.007-3.048,6.984,6.984,0,0,1-.356-3.741,16.853,16.853,0,0,1,1.138-3.565c.473-1.126.911-2.235,1.278-3.353a28.413,28.413,0,0,0,1.409-6.6,19.816,19.816,0,0,0-.368-6.076,15.668,15.668,0,0,0-2.01-4.9,13.84,13.84,0,0,0-5.608-5.148,12.464,12.464,0,0,0-1.969-.726l-.531-.137a.746.746,0,0,1-.18-.059.7.7,0,0,1,.187.023l.542.1a11.079,11.079,0,0,1,2.012.668,13.741,13.741,0,0,1,5.767,5.138,15.817,15.817,0,0,1,2.088,4.968,19.969,19.969,0,0,1,.408,6.172,28.561,28.561,0,0,1-1.4,6.687c-.369,1.126-.813,2.255-1.283,3.378a16.661,16.661,0,0,0-1.114,3.486,6.63,6.63,0,0,0,.336,3.55,8.43,8.43,0,0,0,1.921,2.924,7.449,7.449,0,0,0,5.968,2.388,5.326,5.326,0,0,0,2.8-1.165,4.374,4.374,0,0,0,1.476-2.421,4.647,4.647,0,0,0-.163-2.662,4.425,4.425,0,0,0-1.494-1.962,4.252,4.252,0,0,0-4.067-.692,2.657,2.657,0,0,0-1.335,1.085,1.514,1.514,0,0,0-.123,1.392,1.762,1.762,0,0,0,1.585,1.1A1.326,1.326,0,0,0,310.355,81.768Z",
    transform: "translate(-295.587 -47.852)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.709 156.242)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "translate(111.44 19.356)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.473,312.662c3.425-.966,6.975,2.107,10.443,1.312,2.147-.492,3.707-2.377,4.663-4.361s1.473-4.162,2.488-6.116,2.709-3.759,4.891-4.056c2-.272,4.369.666,5.858-.694,1.151-1.052.991-3.009.078-4.272a9.708,9.708,0,0,0-3.766-2.693,21.3,21.3,0,0,0-4.865-1.927,7.171,7.171,0,0,0-5.094.591c-2.931,1.705-3.532,5.568-4.372,8.853a17.724,17.724,0,0,1-2.876,6.414,9.522,9.522,0,0,1-5.807,3.748,6.316,6.316,0,0,0-2.58.663c-.741.5-1.027,1.778-.263,2.247",
    transform: "translate(-307.819 -289.646)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.255)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M284.84,291.875l12.833-4.442,11.5-17.982a7.64,7.64,0,0,1,5.02-3.392l20.628-3.9a3.389,3.389,0,0,1-1.771,4.132c-2.755,1.574-15.143,4.457-15.143,4.457l19.078-.325s.59,2.755-1.575,3.738-15.755,1.483-15.755,1.483l17.4,2.452s.1,2.762-3.878,2.795a115.264,115.264,0,0,1-11.727-.736.621.621,0,0,0-.7.514h0a.623.623,0,0,0,.472.709l11.57,2.732a1.551,1.551,0,0,1,.118,2.991,1.844,1.844,0,0,1-.647.046c-1.967-.2-13.748-1.69-13.748-1.69s-4.155,14.559-6.848,15.741-8.328,1.495-8.328,1.495l-11.974,4.744Z",
    transform: "translate(-284.84 -262.163)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.78 8.139)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M346.934,273.763a5.3,5.3,0,0,1-1,.1L343.2,274c-2.306.1-5.493.206-9.012.3l-4.964.123a10.794,10.794,0,0,0-3.935.566,4.207,4.207,0,0,0-2.025,1.666,6.726,6.726,0,0,0-.4.9.679.679,0,0,1,.02-.262,2.8,2.8,0,0,1,.253-.711,4.182,4.182,0,0,1,2.047-1.835,10.606,10.606,0,0,1,4.029-.665l4.963-.153c3.52-.1,6.708-.165,9.016-.2l2.734-.018A5.283,5.283,0,0,1,346.934,273.763Z",
    transform: "translate(-322.863 -273.719)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.114 13.441)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M348.174,283.794a4.427,4.427,0,0,1-.923-.066l-2.5-.314c-2.1-.281-5.009-.694-8.213-1.173-1.6-.223-3.131-.516-4.509-.634a6.05,6.05,0,0,0-3.531.637,5.544,5.544,0,0,0-1.824,1.629c-.338.48-.468.784-.5.771-.012,0,.011-.085.067-.232a4.3,4.3,0,0,1,.312-.617,5.3,5.3,0,0,1,1.814-1.775,6.18,6.18,0,0,1,3.682-.749c1.422.1,2.933.386,4.541.609,3.2.478,6.1.932,8.2,1.279l2.478.429A4.489,4.489,0,0,1,348.174,283.794Z",
    transform: "translate(-326.178 -281.246)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.844 18.275)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M338.8,290.249a12.713,12.713,0,0,1-2.018-.437c-1.235-.3-2.938-.75-4.831-1.141a8.812,8.812,0,0,0-1.361-.2,2.612,2.612,0,0,0-1.175.342,4.2,4.2,0,0,0-1.542,1.47,5.457,5.457,0,0,0-.606,1.912,1.194,1.194,0,0,1-.046-.561,3.712,3.712,0,0,1,.426-1.478,4.27,4.27,0,0,1,1.6-1.638,2.893,2.893,0,0,1,1.332-.406,8.363,8.363,0,0,1,1.442.2c1.914.4,3.606.885,4.828,1.251A10.575,10.575,0,0,1,338.8,290.249Z",
    transform: "translate(-327.213 -288.111)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 23.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.166)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M149.593,311.486l38.488-4.732,67.505-10.978,8.715,21.9c-25.381,8.794-51.374,16.72-76.9,23.694a28.679,28.679,0,0,1-6.365.539C172.547,341.939,151.525,338.514,149.593,311.486Z",
    transform: "translate(-149.593 -295.776)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.707)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.951)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M273.813,317.6s-.068-.129-.178-.387l-.48-1.148-1.792-4.394-6.4-15.915.161.092-32.8,5.476c-7.738,1.335-15.173,2.2-21.91,3.089-3.37.444-6.568.893-9.55,1.375q-2.237.362-4.308.741a35.7,35.7,0,0,0-3.923.862,16.026,16.026,0,0,0-5.939,3.385,16.631,16.631,0,0,0-4.581,7.061c-.121.358-.2.635-.253.822a1.712,1.712,0,0,1-.092.279,8.589,8.589,0,0,1,.275-1.123,15.433,15.433,0,0,1,1.285-3.057,16.044,16.044,0,0,1,9.226-7.614,35.548,35.548,0,0,1,3.949-.893q2.071-.388,4.311-.763c2.985-.5,6.184-.955,9.555-1.409,6.74-.911,14.164-1.782,21.9-3.117l32.815-5.407.117-.02.044.111c2.618,6.649,4.774,12.128,6.284,15.962l1.717,4.424.439,1.164C273.774,317.464,273.813,317.6,273.813,317.6Z",
    transform: "translate(-181.764 -295.54)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.166)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M178.994,340.74a2.055,2.055,0,0,1,.308.063l.892.22c.788.17,1.95.437,3.471.623a38.092,38.092,0,0,0,12.885-.62c1.338-.286,2.719-.666,4.161-1.075l4.493-1.266,9.9-2.843c6.965-2.028,14.608-4.307,22.6-6.792,13.41-4.158,25.678-8.226,35.241-11.513l-.087.19c-2.635-6.692-4.791-12.17-6.3-15.993l-1.711-4.4q-.28-.741-.437-1.154c-.1-.262-.136-.4-.136-.4s.067.127.176.384l.476,1.14,1.783,4.375c1.533,3.812,3.73,9.274,6.414,15.946l.056.14-.144.05c-9.55,3.333-21.814,7.432-35.228,11.59-8,2.485-15.644,4.756-22.616,6.766l-9.912,2.811-4.5,1.245c-1.441.4-2.835.778-4.183,1.056a37.463,37.463,0,0,1-12.957.509A24.521,24.521,0,0,1,178.994,340.74Z",
    transform: "translate(-178.994 -295.776)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 34.634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M189.841,311.355a4.994,4.994,0,0,1-.965.143l-2.64.266-8.709.853-8.7.929-2.639.275a4.953,4.953,0,0,1-.974.055,4.982,4.982,0,0,1,.956-.2c.618-.1,1.516-.237,2.626-.392,2.22-.308,5.294-.687,8.7-1.036s6.489-.6,8.725-.747c1.118-.075,2.024-.125,2.651-.149A4.937,4.937,0,0,1,189.841,311.355Z",
    transform: "translate(-165.211 -311.337)"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.363 1.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M280.057,364.754c0,5.142,2.981,103.842,2.981,103.842l-42.027-.212-7.345-43.868-1.934,43.868H191.418l4.377-108.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M156.242,323.882l-21.465-32L150.7,278.944l26.924,24.972S189.218,238.939,200.633,235l-.889,100.8h0A34.5,34.5,0,0,1,156.242,323.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M112.3,173.195l4.565,62.3,74.778,143.341,43.228-25.039L161.177,213.707Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "af"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M161.914,213.975a4.4,4.4,0,0,1-6.393,1.254,11.116,11.116,0,0,1-17.775,11.3,12.969,12.969,0,0,1-20.915,8.495L112.3,173.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M114.133,198.248s10.133,6.362,18.19-8.455L112.3,173.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M208.117,367.124c-.128.065-16.026-31.31-35.5-70.067-19.485-38.772-35.171-70.244-35.042-70.308s16.023,31.3,35.507,70.074S208.246,367.06,208.117,367.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M226.091,356.369c-.129.064-16.027-31.31-35.505-70.068s-35.17-70.244-35.042-70.308,16.023,31.3,35.508,70.074S226.219,356.3,226.091,356.369Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M138.173,256.651l-9.7,3.875-2.079,7.815,3.341,13.036,7.834,8.31,5.285-4.369.332-7.98.646-4.466s4.782-1.5,4.9-2.232-.593-3.185-1.327-3.3-5.749,1.749-5.749,1.749,5.937-4.7,5.771-5.454-.8-2.685-1.988-2.9-10.764,4.3-10.764,4.3l-1.555,3.546-1.357-5.671S140.277,260.521,138.173,256.651Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M139.393,274.975c-.057.018-.239-.336-.328-.966a5.262,5.262,0,0,1,1.664-4.5c.478-.42.846-.571.878-.52a7.428,7.428,0,0,0-2.214,5.982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M134.784,273.282a21.245,21.245,0,0,0,.384-2.542,11.062,11.062,0,0,1,.488-2.814,4.154,4.154,0,0,1,.893-1.5,4.435,4.435,0,0,1,1.585-1c2.32-.841,4.408-1.522,5.937-2.016a13.364,13.364,0,0,1,2.505-.69,13.269,13.269,0,0,1-2.388,1.024c-1.489.576-3.591,1.322-5.866,2.147a4.039,4.039,0,0,0-1.421.874,3.8,3.8,0,0,0-.812,1.32,12.237,12.237,0,0,0-.569,2.7A5.212,5.212,0,0,1,134.784,273.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M132.558,271.529c-.136-.023-.108-.879.062-1.912s.42-1.854.556-1.831.109.879-.062,1.912S132.7,271.552,132.558,271.529Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M263.7,216.37l-8.5-2.891-31.779,7.295-2.815,2.332L203.776,378.834c7.225,7.449,30,8.927,42.932,6.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M264.292,216.665l-4.089-2.044s-9,39.643-9,65.827-5.657,121.109-5.657,121.109l42.871-1.1V295.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M203.776,403.145l-16.242-4.757,5.667-76.747-1.075-55.634L200.633,235l20.161-12.457S204.886,393.9,203.776,403.145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M237.657,235.53h0A15.649,15.649,0,0,1,223.4,219.883l.052-13.925s-12.865-2-13.024-14.863,2.072-42.4,2.072-42.4h0a44.7,44.7,0,0,1,44.919,5.647l1.906,1.467-4.665,65.248A15.649,15.649,0,0,1,237.657,235.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M223.427,205.772a29.906,29.906,0,0,0,16.769-4.765s-3.964,9.257-16.8,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M257.736,169.133c.219-.1,8.838-2.614,8.557,6.18s-9.052,6.7-9.059,6.445S257.736,169.133,257.736,169.133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M260.027,178.512c.039-.026.15.113.4.24a1.534,1.534,0,0,0,1.144.06c.94-.312,1.769-1.762,1.863-3.345a5.066,5.066,0,0,0-.359-2.207,1.771,1.771,0,0,0-1.115-1.213.78.78,0,0,0-.917.391c-.126.242-.076.42-.123.433-.025.021-.184-.153-.1-.514a.985.985,0,0,1,.364-.54,1.155,1.155,0,0,1,.854-.2,2.155,2.155,0,0,1,1.557,1.415,5.2,5.2,0,0,1,.453,2.468c-.113,1.77-1.073,3.4-2.356,3.726a1.641,1.641,0,0,1-1.394-.278C260.036,178.726,260,178.527,260.027,178.512Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M216.713,168.487a1.836,1.836,0,0,0,1.771,1.853,1.758,1.758,0,0,0,1.894-1.656,1.839,1.839,0,0,0-1.77-1.855A1.759,1.759,0,0,0,216.713,168.487Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M214.93,166.791c.227.239,1.619-.791,3.6-.785,1.974-.024,3.425.993,3.639.751.106-.107-.126-.539-.758-1a5.04,5.04,0,0,0-2.913-.9,4.844,4.844,0,0,0-2.863.924C215.023,166.25,214.818,166.683,214.93,166.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M236.143,169.32a1.837,1.837,0,0,0,1.771,1.853,1.757,1.757,0,0,0,1.894-1.656,1.837,1.837,0,0,0-1.77-1.854A1.757,1.757,0,0,0,236.143,169.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M234.359,167.159c.228.24,1.622-.79,3.6-.785,1.974-.023,3.425.994,3.64.752.105-.107-.125-.539-.759-1a5.04,5.04,0,0,0-2.913-.9,4.844,4.844,0,0,0-2.863.924C234.455,166.619,234.248,167.052,234.359,167.159Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M227.186,181.819a13.057,13.057,0,0,0-3.211-.58c-.5-.052-.982-.152-1.067-.5a2.568,2.568,0,0,1,.337-1.5l1.492-3.843c2.073-5.472,3.574-9.972,3.353-10.054s-2.081,4.288-4.154,9.761q-.749,2.023-1.43,3.866a2.92,2.92,0,0,0-.261,1.981,1.265,1.265,0,0,0,.829.738,3.42,3.42,0,0,0,.858.119A12.891,12.891,0,0,0,227.186,181.819Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M233.849,159.413c.2.537,2.169.283,4.488.562,2.325.233,4.195.912,4.5.43.137-.23-.188-.736-.945-1.256a7.856,7.856,0,0,0-6.849-.756C234.194,158.736,233.765,159.158,233.849,159.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M215.656,161.07c.348.449,1.71-.017,3.347-.039,1.637-.079,3.024.3,3.343-.168.14-.228-.078-.678-.684-1.1a4.848,4.848,0,0,0-5.39.167C215.693,160.388,215.5,160.851,215.656,161.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M206.229,140.576a4.749,4.749,0,0,1,1.753-4.243,3.369,3.369,0,0,1,4.364.327,3.931,3.931,0,0,1,3.379-4.767c2.1-.133,3.887,1.452,5.914,2.008a9.554,9.554,0,0,0,6.006-.694c1.9-.766,3.682-1.824,5.609-2.528a16.449,16.449,0,0,1,21.038,9.658c2.813-.879,6.009.55,7.744,2.932a11.983,11.983,0,0,1,1.834,8.44,26.809,26.809,0,0,1-1.47,5.771c0,.166.016.328.013.494-.133,7.073-.932,15.379-3.95,15.425-5.259.081-4.006-9.828-4.006-9.828-6.455-2.494-4.05-12.165-5.664-13.632s-4.99-4.876-18.5,2.031c-5.247,2.682-12.224,2.6-16.033,1.734-.112-.024-.225-.041-.336-.068-.024-.006-.055-.01-.079-.016-.041-.011-.071-.034-.111-.045a12.2,12.2,0,0,1-3.466-1.471,6.846,6.846,0,0,1-2.856-3.175,3.75,3.75,0,0,1,.737-4.026A8.252,8.252,0,0,1,206.229,140.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M225.508,187.9a8.826,8.826,0,0,0,1.147,2.247,2.982,2.982,0,0,0,2.121,1.231,2.676,2.676,0,0,0,2.265-1.235,4.274,4.274,0,0,0,.632-2.576c-.037-.812-.409-1.781-1.216-1.877a2.044,2.044,0,0,0-.98.217l-4.243,1.721"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M227.2,191.39a6.142,6.142,0,0,0,2.263-.28,3.228,3.228,0,0,0,1.71-1.554,3.406,3.406,0,0,0,.056-2.776,3.021,3.021,0,0,0-.37-.634c-.168-.176-.137-.168-.32-.141-.173.046-.452.178-.68.267l-.7.283c-.908.368-1.73.689-2.424.948a7.748,7.748,0,0,1-2.311.7,7.752,7.752,0,0,1,2.1-1.188c.668-.323,1.468-.7,2.361-1.1l.687-.308a7.623,7.623,0,0,1,.775-.319.989.989,0,0,1,.629.018,1.166,1.166,0,0,1,.468.37,3.635,3.635,0,0,1,.477.8,3.977,3.977,0,0,1-.129,3.394,3.627,3.627,0,0,1-2.154,1.741,3.427,3.427,0,0,1-1.838.072C227.384,191.575,227.186,191.432,227.2,191.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M249.219,148.74a7.784,7.784,0,0,0,.007-1.557,6.077,6.077,0,0,0-2.011-3.612,8.184,8.184,0,0,0-5.791-1.913,25.222,25.222,0,0,0-7.524,1.683c-1.314.433-2.61.846-3.895,1.13a20.158,20.158,0,0,1-3.761.457,20.417,20.417,0,0,1-6.337-.833,19.722,19.722,0,0,1-3.966-1.682c-.445-.246-.775-.463-1-.615a1.632,1.632,0,0,1-.327-.245c.021-.033.491.275,1.393.73a21.832,21.832,0,0,0,3.97,1.555,20.833,20.833,0,0,0,6.252.741,20.209,20.209,0,0,0,3.691-.47c1.263-.284,2.544-.695,3.857-1.128a24.911,24.911,0,0,1,7.639-1.672,8.387,8.387,0,0,1,5.977,2.065,6.081,6.081,0,0,1,1.975,3.792A3.552,3.552,0,0,1,249.219,148.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M259.22,170.478a1.093,1.093,0,0,1-.169-.271c-.1-.182-.237-.458-.4-.82a16.523,16.523,0,0,1-1.024-3.2,17.621,17.621,0,0,1-.332-4.972,44.3,44.3,0,0,1,1.148-5.976,11.708,11.708,0,0,0,.012-5.911,5.974,5.974,0,0,0-1.233-2.241,4.513,4.513,0,0,0-1.848-1.212,4.219,4.219,0,0,0-3.174.081,6.177,6.177,0,0,0-.988.692,2.462,2.462,0,0,1,.92-.823,4.272,4.272,0,0,1,3.328-.2,4.736,4.736,0,0,1,1.995,1.255,6.23,6.23,0,0,1,1.333,2.347,11.847,11.847,0,0,1,.026,6.093,47.587,47.587,0,0,0-1.171,5.927,18.252,18.252,0,0,0,.246,4.891,19.161,19.161,0,0,0,.9,3.2A11.581,11.581,0,0,1,259.22,170.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M250.454,147.7a2.748,2.748,0,0,1,.005-.517c.014-.375.033-.864.055-1.475a17.075,17.075,0,0,0-.594-5.342,9.442,9.442,0,0,0-1.718-3.244,6.64,6.64,0,0,0-3.449-2.279,8.713,8.713,0,0,0-4.6.189,21.3,21.3,0,0,0-4.6,2.086,37.946,37.946,0,0,1-4.564,2.348,13.936,13.936,0,0,1-4.7.945,14.875,14.875,0,0,1-4.308-.529,16.633,16.633,0,0,1-3.495-1.44,14.278,14.278,0,0,1-4.138-3.532,8.964,8.964,0,0,1-.839-1.223,2.652,2.652,0,0,1-.249-.452,2.629,2.629,0,0,1,.313.411,11.244,11.244,0,0,0,.889,1.171,14.816,14.816,0,0,0,4.154,3.391,16.739,16.739,0,0,0,3.447,1.371,14.7,14.7,0,0,0,4.216.483,13.739,13.739,0,0,0,4.577-.94,38.515,38.515,0,0,0,4.515-2.334,21.4,21.4,0,0,1,4.688-2.113,9.019,9.019,0,0,1,4.795-.169,6.936,6.936,0,0,1,3.6,2.417,9.621,9.621,0,0,1,1.732,3.367,16.348,16.348,0,0,1,.485,5.424c-.038.643-.088,1.139-.127,1.476A2.609,2.609,0,0,1,250.454,147.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M264.292,216.665s30.671,9.815,32.715,15.131c1.534,3.987,17.649,52.362,21.126,83.891a23.154,23.154,0,0,1-20.967,25.494c-20.766,1.908-50.919,4.385-50.919,2.678V317.713l39.059-5.766-14.471-42.529Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M224.925,338.575c4.006,1.039,21.322,1.039,21.322,1.039V319.075s-7.534-3.219-9.614-5.091-7.987-12.919-7.987-12.919a5.92,5.92,0,0,0-2.717,6.323c.971,4.511,2.838,5.06,2.965,6.857,0,.019.155.462.158.481.4,2.5-1.989,4.709-1.989,4.709a8.725,8.725,0,0,0-2.629-1.345c-3.647-.431-7.972,2.182-7.972,3.64,0,0-.126,3.933,0,4.516s1.973,1.361,1.973,1.361-.584,2.624,0,3.791a6.134,6.134,0,0,0,2.527,2.041S222.667,337.99,224.925,338.575Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M229.126,335.282a13.026,13.026,0,0,1-8.06-1.762c.062-.14,1.782.55,4,1.027S229.127,335.128,229.126,335.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M228.11,329.127a12.816,12.816,0,0,1-9.222-1.233c.06-.146,2.018.638,4.565.967C226,329.212,228.091,328.97,228.11,329.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M227.512,311.49a7.841,7.841,0,0,1,1.392,2.541,9.4,9.4,0,0,1,.443,1.416,3.4,3.4,0,0,1-.018,1.757,5.2,5.2,0,0,1-2.479,3.033,6.453,6.453,0,0,1-1.912.753,11.6,11.6,0,0,1-1.873.193c-1.185.041-2.241.022-3.126.044-1.773.009-2.832.264-2.855.2a6.932,6.932,0,0,1,2.838-.564c.892-.069,1.954-.088,3.119-.156a11.887,11.887,0,0,0,1.79-.212,6.151,6.151,0,0,0,1.755-.7,4.843,4.843,0,0,0,2.281-2.715,3,3,0,0,0,.056-1.542,10.149,10.149,0,0,0-.365-1.375C227.993,312.488,227.443,311.529,227.512,311.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M285.794,311.882a10.5,10.5,0,0,1-1.539.326l-4.224.723c-3.569.59-8.505,1.371-13.963,2.2s-10.408,1.536-13.995,2.009a36.208,36.208,0,0,1-5.826.577l1.544-.263,4.229-.679,13.97-2.159c5.457-.824,10.4-1.549,13.986-2.045l4.249-.56A8.053,8.053,0,0,1,285.794,311.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M302.376,308.007a17.931,17.931,0,0,1-3.079-.026c-1.9-.082-4.517-.232-7.408-.429a14.386,14.386,0,0,0-4,.045,4.025,4.025,0,0,0-2.6,1.651,2.808,2.808,0,0,0-.367,2.048c.118.5.309.735.271.761-.017.018-.272-.178-.466-.705a2.883,2.883,0,0,1,.244-2.29,4.306,4.306,0,0,1,2.811-1.933,13.8,13.8,0,0,1,4.141-.1c2.89.2,5.506.4,7.4.581A17.962,17.962,0,0,1,302.376,308.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M295.945,315.173a63.032,63.032,0,0,1-10.981-3.248,62.97,62.97,0,0,1,10.981,3.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M271.716,264.011c.138-.042,3.288,9.9,7.036,22.207s6.676,22.32,6.538,22.362-3.287-9.9-7.036-22.21S271.579,264.052,271.716,264.011Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M294.618,232.54c.021.1-1.8.371-4.529,1.428a26.969,26.969,0,0,0-15.606,15.715c-1.037,2.741-1.3,4.56-1.4,4.539a5.385,5.385,0,0,1,.149-1.277,22.823,22.823,0,0,1,.9-3.388,25.861,25.861,0,0,1,15.824-15.934,22.787,22.787,0,0,1,3.381-.925A5.365,5.365,0,0,1,294.618,232.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M192.537,253.873a3.543,3.543,0,0,1,.058.695c.017.508.04,1.17.067,1.994.037,1.792.087,4.282.149,7.332.076,6.245.179,14.771.294,24.191.055,9.423.105,17.951.141,24.2-.007,3.05-.012,5.54-.017,7.333l-.031,1.994a3.427,3.427,0,0,1-.046.7,3.545,3.545,0,0,1-.058-.7c-.017-.508-.04-1.169-.067-1.993-.037-1.792-.087-4.281-.149-7.331-.076-6.246-.179-14.773-.294-24.2-.055-9.42-.1-17.947-.141-24.192.007-3.051.012-5.541.016-7.333.013-.824.024-1.486.031-1.994A3.45,3.45,0,0,1,192.537,253.873Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M240.891,467.078a4.2,4.2,0,0,1-.207-.749c-.124-.545-.289-1.267-.5-2.171-.421-1.888-1-4.626-1.677-8.015-1.365-6.778-3.11-16.171-4.776-26.589s-2.929-19.893-3.744-26.759c-.408-3.433-.715-6.214-.9-8.138l-.207-2.217a4.324,4.324,0,0,1-.036-.777,4.461,4.461,0,0,1,.141.765q.114.829.3,2.2c.259,1.971.622,4.73,1.066,8.115.908,6.852,2.232,16.308,3.893,26.723s3.352,19.809,4.623,26.6l1.515,8.044q.249,1.368.4,2.19A4.429,4.429,0,0,1,240.891,467.078Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M297.166,341.181c.01.143-11.266,1-25.181,1.92s-25.209,1.545-25.218,1.4,11.263-1,25.183-1.921S297.157,341.037,297.166,341.181Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.05b60636b7ad7bc4b01260b400db9ce5.svg";
export { ForwardRef as ReactComponent };